import Enums from "../../enums/enums";
import peakUtility from "../../function/peakUtility.js";
import userInfo from "../../function/userInfo";
import billingNoteHelper from "../../helper/billingNoteHelper.js";
import { SetSubAccountForPaymentTransactionChartAccount, default as paymentHelper } from "../../helper/paymentHelper";
import {
  GetAllocationListWithOutZeroPercent,
  GetAllocationTransactionEquals,
  GetTransactionItemList,
  GetTransactionSummary,
  SetTransactionItemList,
  default as transactionItemHelper,
} from "../../helper/transactionItemHelper";
import transactionHelper from "../../helper/transactionItemHelper.js";
import i18n from "../../locales/i18n";

export const GetCreateAllocationTransaction = (allocationTransactionRawList) => {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
        };
        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationValue: allocationItemRaw.percent.ToNumber(),
              allocationValueType: Enums.AllocationValueType.Percent,
              allocationPercent: allocationItemRaw.percent.ToNumber(),
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
};
export const GetCreateAllocationJournal = (allocationTransactionRawList) => {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
        };
        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationDebit: allocationItemRaw.percent.ToNumber(),
              allocationCredit: allocationItemRaw.percent.ToNumber(),
              allocationValueType: Enums.AllocationValueType.Percent,
              allocationPercent: allocationItemRaw.percent.ToNumber(),
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
};
export const GetCreateAllocationJournalItem = (allocationTransactionRawList) => {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
        };
        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationDebit: allocationItemRaw.isDebit ? allocationItemRaw.amount.ToNumber() : 0,
              allocationCredit: allocationItemRaw.isDebit ? 0 : allocationItemRaw.amount.ToNumber(),
              allocationValueType: allocationItemRaw.valueType,
              allocationPercent: allocationItemRaw.percent.ToNumber(),
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
};
export const GetCreateAllocationTransactionItem = (allocationTransactionRawList) => {
  let allocationTransactionList = [];
  if (allocationTransactionRawList && allocationTransactionRawList.length > 0) {
    for (let allocationTransactionRaw of allocationTransactionRawList) {
      if (
        allocationTransactionRaw.allocationId &&
        allocationTransactionRaw.allocationItemList &&
        allocationTransactionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransactionRaw.allocationId,
          allocationItemList: [],
        };
        for (let allocationItemRaw of allocationTransactionRaw.allocationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationValue: allocationItemRaw.amount.ToNumber(),
              allocationValueType: allocationItemRaw.valueType,
              allocationPercent: allocationItemRaw.percent.ToNumber(),
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
};
export const GetCreateAllocationTransactionItemList = (allocationTransactionItemRawList) => {
  let allocationTransactionItemList = [];
  if (allocationTransactionItemRawList && allocationTransactionItemRawList.length > 0) {
    for (let allocationTransactionItemRaw of allocationTransactionItemRawList) {
      let allocationTransactionItem = {
        transactionItemId: allocationTransactionItemRaw.transactionItemId,
        allocationTransactionList: GetCreateAllocationTransaction(
          allocationTransactionItemRaw.allocationTransactionList
        ),
      };
      allocationTransactionItemList.push(allocationTransactionItem);
    }
  }
  return allocationTransactionItemList;
};
function GetExpenseTypeForGetSuggestionTransactionNumber(_transaction) {
  let expenseType = _transaction.expenseType;
  if (_transaction.expenseType === Enums.ExpenseType.PurchaseInventory) {
    expenseType = Enums.ExpenseType.Expense;
  } else if (_transaction.transactionItemType) {
    expenseType = _transaction.transactionItemType;
  }
  return expenseType;
}
const GetAmountBeforeDiscountDetail = (transactionRawData) => {
  let amountBeforeDiscount = 0;
  const taxStatus = transactionRawData.taxStatus;
  if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
    transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
      if (taxStatus === Enums.TaxTypeId.IncludeTax) {
        amountBeforeDiscount +=
          transactionItemRawData.toCurrencyPreVatTotal +
          transactionItemRawData.toCurrencyZeroVatTotal +
          transactionItemRawData.toCurrencyVatExemptedTotal +
          transactionItemRawData.toCurrencyVatTotal;
      } else {
        amountBeforeDiscount +=
          transactionItemRawData.toCurrencyPreVatTotal +
          transactionItemRawData.toCurrencyZeroVatTotal +
          transactionItemRawData.toCurrencyVatExemptedTotal;
      }
    });
  }
  return amountBeforeDiscount;
};
const GetReferenceDepositTotalDetail = (transactionRawData) => {
  let referenceDepositTotal = 0;
  if (transactionRawData) {
    const toCurrencyDepositPreVatTotal = transactionRawData.toCurrencyDepositPreVatTotal
      ? transactionRawData.toCurrencyDepositPreVatTotal
      : 0;
    const toCurrencyDepositVatExemptedTotal = transactionRawData.toCurrencyDepositVatExemptedTotal
      ? transactionRawData.toCurrencyDepositVatExemptedTotal
      : 0;
    const toCurrencyDepositZeroVatTotal = transactionRawData.toCurrencyDepositZeroVatTotal
      ? transactionRawData.toCurrencyDepositZeroVatTotal
      : 0;
    const toCurrencyDepositVatTotal = transactionRawData.toCurrencyDepositVatTotal
      ? transactionRawData.toCurrencyDepositVatTotal
      : 0;
    if (transactionRawData.taxStatus === Enums.TaxStatus.ExcludeTax) {
      referenceDepositTotal =
        toCurrencyDepositPreVatTotal + toCurrencyDepositVatExemptedTotal + +toCurrencyDepositZeroVatTotal;
    } else {
      referenceDepositTotal =
        toCurrencyDepositPreVatTotal +
        toCurrencyDepositVatExemptedTotal +
        toCurrencyDepositZeroVatTotal +
        toCurrencyDepositVatTotal;
    }
  }
  return referenceDepositTotal;
};
const GetAmountAfterDiscountDetail = (amountBeforeDiscount, referenceDepositTotal, discount, discountType) => {
  let amountAfterDiscount = amountBeforeDiscount;
  if (discountType == Enums.DiscountType.Currency) {
    amountAfterDiscount = amountAfterDiscount - discount;
  } else {
    amountAfterDiscount = amountAfterDiscount - (amountAfterDiscount * discount) / 100;
  }

  amountAfterDiscount = amountAfterDiscount - referenceDepositTotal;

  return amountAfterDiscount;
};
function ConvertToTransactionDetailBaseModel(transactionRawData) {
  let transactionDetailTemplate = {
    referenceName: transactionRawData.referenceName,
    id: transactionRawData.id,
    number: transactionRawData.number,
    date: transactionRawData.date,
    isVat: transactionRawData.isVat,
    isDeleted: transactionRawData.isDeleted,
    discount: transactionRawData.toCurrency.discount,
    discountType: transactionRawData.discountType,
    remark: transactionRawData.remark,
    contactId: transactionRawData.contactId,
    transactionType: transactionRawData.transactionType,
    financeType: transactionRawData.financeType,
    expenseType: transactionRawData.transactionItemType,
    transactionItemType: transactionRawData.transactionItemType,
    taxStatus: transactionRawData.taxStatus,
    userId: transactionRawData.createdUserId,
    lockStatusId: transactionRawData.lockStatus,
    lockUserId: transactionRawData.lockUserId,
    lockDatetime: transactionRawData.lockDatetime,
    transactionCreateStatus: transactionRawData.createStatus,
    isAllocation: transactionRawData.isAllocation,
    createdDateTime: transactionRawData.createdDateTime,
    approvedUserId: transactionRawData.approvedUserId,
    approvedDateTime: transactionRawData.approvedDateTime,
    transactionSummary: {
      discount: transactionRawData.fromCurrency.discount,
      preVatTotal: transactionRawData.fromCurrency.preVatTotal,
      zeroVatTotal: transactionRawData.fromCurrency.zeroVatTotal,
      vatExemptedTotal: transactionRawData.fromCurrency.vatExemptedTotal,
      vatTotal: transactionRawData.fromCurrency.vatTotal,
      subTotal: 0,
      netAmount: transactionRawData.fromCurrency.netTotal,
      subTotalForCalculateWht: transactionRawData.fromCurrency.subTotalForcalculateWHT,
      whtTotal: transactionRawData.fromCurrency.whtTotal,
      remainPaymentNetAmount: 0,
      remainWhtPaymentNetAmount: 0,
      isAllNoneOrNotSpecifyWht: transactionRawData.isNoneOrNotSpecifyWht,
      isServiceOnly: transactionRawData.isServiceOnly,
      sameProductVatType: transactionRawData.sameProductVatType,
    },
    transactionCurrency: {
      discount: transactionRawData.toCurrency.discount,
      fromCurrencyUid: transactionRawData.fromCurrencyUId,
      toCurrencyUid: transactionRawData.toCurrencyUId,
      currencyExchangeRates: transactionRawData.currencyExchangeRates,
      currencyRatio: transactionRawData.currencyRatio,
      currencyPreVatTotal: transactionRawData.toCurrency.preVatTotal,
      currencyZeroVatTotal: transactionRawData.toCurrency.zeroVatTotal,
      currencyVatExemptedTotal: transactionRawData.toCurrency.vatExemptedTotal,
      currencyVatTotal: transactionRawData.toCurrency.vatTotal,
      currencySubTotal: 0,
      currencyNetAmount: transactionRawData.toCurrency.netTotal,
      currencySubTotalForCalculateWht: transactionRawData.toCurrency.subTotalForcalculateWHT,
      currencyWhtTotal: transactionRawData.toCurrency.whtTotal,
      amountBeforeDiscount: 0,
      referenceDepositTotal: 0,
      amountAfterDiscount: 0,
    },
    transactionItems: [],
    allocationList: GetAllocationListWithOutZeroPercent(transactionRawData.allocationTransactionList),
  };

  transactionDetailTemplate.transactionCurrency.amountBeforeDiscount =
    GetAmountBeforeDiscountDetail(transactionRawData);
  transactionDetailTemplate.transactionCurrency.referenceDepositTotal =
    GetReferenceDepositTotalDetail(transactionRawData);
  transactionDetailTemplate.transactionCurrency.amountAfterDiscount = GetAmountAfterDiscountDetail(
    transactionDetailTemplate.transactionCurrency.amountBeforeDiscount,
    transactionDetailTemplate.transactionCurrency.referenceDepositTotal,
    transactionDetailTemplate.discount,
    transactionDetailTemplate.discountType
  );

  return transactionDetailTemplate;
}

function ConvertToTransactionItemDetailBaseModel(transactionRawData, transactionItemRawData, allocateDiscountPercent) {
  const transactionItemTemplate = {
    id: transactionItemRawData.id,
    description: transactionItemRawData.description,
    price: transactionItemRawData.toCurrencyPrice,
    amount: transactionItemRawData.quantity,
    discount: transactionItemRawData.toCurrencyDiscount,
    vatType: transactionItemRawData.vatType,
    discountType: transactionItemRawData.discountType,
    netAmount: transactionItemRawData.toCurrencyNetTotal - transactionItemRawData.toCurrencyVatTotal,
    isDescriptionOnly: transactionItemRawData.isDescriptionOnly,
    vatAmount: transactionItemRawData.toCurrencyVatTotal,
    whtPercent: 0,
    whtAmount: transactionItemRawData.toCurrencyWHTTotal,
    whtAmountType: transactionItemRawData.whtAmountType,
    subTotal: transactionItemRawData.toCurrencySubTotalForcalculateWHT,
    sequenceNumber: transactionItemRawData.sequenceNumber,
    isUseTransactionAllocation: true,
    itemNetAmountWithAllocateDiscountForAllocation: 0,
    itemNetAmountWithAllocateDiscountTotal: 0,
    allocationList: GetAllocationListWithOutZeroPercent(transactionItemRawData.allocationTransactionList),
  };
  if (transactionItemTemplate.allocationList && transactionItemTemplate.allocationList.length > 0) {
    let allocationTransactionEquals = GetAllocationTransactionEquals(
      GetAllocationListWithOutZeroPercent(transactionRawData.allocationTransactionList),
      transactionItemTemplate.allocationList
    );
    transactionItemTemplate.isUseTransactionAllocation = allocationTransactionEquals;
  }

  let transactionItemForCalculateProductTotalPrice =
    transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPriceNewModel(transactionItemRawData);
  let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
    transactionItemForCalculateProductTotalPrice,
    allocateDiscountPercent,
    transactionRawData.toCurrencyUid,
    transactionRawData.currencyExchangeRates,
    transactionRawData.currencyRatio,
    transactionRawData.taxStatus,
    transactionRawData.isCreatedTaxInvoice,
    transactionRawData.transactionType,
    transactionRawData.financeType,
    false
  );

  transactionItemTemplate.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
  transactionItemTemplate.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

  return transactionItemTemplate;
}
function SetRemainPaymentDetail(transaction, transactionRawData) {
  transaction.billedCount = transactionRawData.remainPaymentDetail.billedCount;
  transaction.billedTotal = transactionRawData.remainPaymentDetail.billedAmount;
  transaction.billedTotalAwaitPaidPayment = transactionRawData.remainPaymentDetail.billedTotalAwaitPaidPayment;
  transaction.billedWhtTotal = transactionRawData.remainPaymentDetail.billedWhtTotal;
  transaction.creditNoteCount = transactionRawData.remainPaymentDetail.creditNoteCount;
  transaction.creditNoteTotal = transactionRawData.remainPaymentDetail.creditNoteTotal;
  transaction.creditNoteWhtTotal = transactionRawData.remainPaymentDetail.creditNoteWhtTotal;
  transaction.debitNoteCount = transactionRawData.remainPaymentDetail.debitNoteCount;
  transaction.referencePaymentDocumentTotalAwaitPaid =
    transactionRawData.remainPaymentDetail.referencePaymentDocumentTotalAwaitPaid;
  transaction.referencePaymentDocumentTotal = transactionRawData.remainPaymentDetail.referencePaymentDocumentTotal;
  transaction.referencePaymentDocumentCount = transactionRawData.remainPaymentDetail.referencePaymentDocumentCount;
  transaction.paymentCount =
    transaction.transactionType == Enums.TransactionType.Receipt
      ? 1
      : transactionRawData.remainPaymentDetail.paymentCount;
  transaction.isHavePayment = transaction.paymentCount > 0;
  transaction.isHavePnd = transactionRawData.remainPaymentDetail.isHavePnd;
  transaction.paidTotal = transactionRawData.remainPaymentDetail.paymentTotal;
  transaction.transactionSummary.remainPaymentNetAmount = transactionRawData.remainPaymentDetail.remainPaymentAmount;
  transaction.transactionSummary.remainWhtPaymentNetAmount =
    transactionRawData.remainPaymentDetail.remainWhtPaymentAmount;
}
function ConvertToTransactionDetail(_transaction) {
  let transactionDetailTemplate = {
    referenceName: _transaction.referenceName,
    id: _transaction.id,
    number: _transaction.number,
    uuid: _transaction.uuid,
    date: _transaction.date,
    dueDate: _transaction.dueDate ? _transaction.dueDate : null,
    actionDate: _transaction.actionDate,
    rejectDate: _transaction.rejectDate,
    isVat: _transaction.isVat,
    isDeleted: _transaction.isDeleted,
    discount: _transaction.discount,
    discountType: _transaction.discountType,
    remark: _transaction.remark,
    transactionStatus: _transaction.transactionStatus,
    contactId: _transaction.contactId,
    contactCode: "",
    transactionType: _transaction.transactionType,
    financeType: _transaction.financeType,
    expenseType: _transaction.expenseType,
    transactionItemType: _transaction.transactionItemType,
    taxStatus: _transaction.taxStatus,
    userId: _transaction.userId,
    lockStatusId: _transaction.lockStatusId,
    transactionCreateStatus: _transaction.createStatus,
    referenceDepositSummary: ConvertTorReferenceDepositSummaryDetail(_transaction),
    transactionSummary: {
      preVatTotal: _transaction.transactionSummary.preVatTotal,
      zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
      vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
      taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
      vatTotal: _transaction.transactionSummary.vatTotal,
      subTotal: _transaction.transactionSummary.subTotal,
      netAmount: _transaction.transactionSummary.netAmount,
      subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
      whtTotal: _transaction.transactionSummary.whtTotal,
      remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
      remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
      isAllNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
      isServiceOnly: _transaction.transactionSummary.isServiceOnly,
      sameProductVatType: _transaction.transactionSummary.sameProductVatType,
      referenceTransactionToCurrencyNetTotal: _transaction.transactionSummary.referenceTransactionToCurrencyNetTotal,
    },
    transactionCurrency: {
      fromCurrencyUid: _transaction.transactionCurrency.fromCurrencyUid,
      toCurrencyUid: _transaction.transactionCurrency.toCurrencyUid,
      fromCurrencyCode: _transaction.transactionCurrency.fromCurrencyCode,
      toCurrencyCode: _transaction.transactionCurrency.toCurrencyCode,
      fromCurrencyCountryName: _transaction.transactionCurrency.fromCurrencyCountryName,
      toCurrencyCountryName: _transaction.transactionCurrency.toCurrencyCountryName,
      currencyExchangeRates: _transaction.transactionCurrency.currencyExchangeRates,
      currencyRatio: _transaction.transactionCurrency.currencyRatio,
      currencyPreVatTotal: _transaction.transactionCurrency.currencyPreVatTotal,
      currencyZeroVatTotal: _transaction.transactionCurrency.currencyZeroVatTotal,
      currencyVatExemptedTotal: _transaction.transactionCurrency.currencyVatExemptedTotal,
      currencyTaxExclusiveTotal: _transaction.transactionCurrency.currencyTaxExclusiveTotal,
      currencyVatTotal: _transaction.transactionCurrency.currencyVatTotal,
      currencySubTotal: _transaction.transactionCurrency.currencySubTotal,
      currencyNetAmount: _transaction.transactionCurrency.currencyNetAmount,
      currencySubTotalForCalculateWht: _transaction.transactionCurrency.currencySubTotalForCalculateWht,
      currencyWhtTotal: _transaction.transactionCurrency.currencyWhtTotal,
      amountBeforeDiscount: 0,
      referenceDepositTotal: 0,
      amountAfterDiscount: 0,
    },
    transactionItems: [],
    allocationList: GetAllocationListWithOutZeroPercent(_transaction.allocationTransactionList),
  };

  let transactionListForCalculateAllocateDiscountPercent =
    transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
      _transaction.taxStatus,
      _transaction.transactionItemList
    );

  let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
    transactionListForCalculateAllocateDiscountPercent,
    _transaction.discount,
    _transaction.discountType,
    _transaction.taxStatus
  );

  if (_transaction.transactionItemList && _transaction.transactionItemList.length > 0) {
    _transaction.transactionItemList.forEach((transactionItems) => {
      let transactionItemAmount = 0;
      let transactionItemTotal = 0;
      let transactionItemPrice = 0;
      let transactionItemDiscount = 0;
      let transactionItemPriceTotal = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemDiscountTypeId = 0;

      if (!transactionItems.isDescriptionOnly) {
        transactionItemAmount = transactionItems.amount ? transactionItems.amount.ToNumber() : 0;
        transactionItemPrice = transactionItems.price ? transactionItems.price.ToNumber() : 0;
        transactionItemDiscount = transactionItems.discount ? transactionItems.discount.ToNumber() : 0;
        transactionItemDiscountTypeId = transactionItems.discountType
          ? transactionItems.discountType.ToNumber()
          : Enums.DiscountType.Currency;
      }

      if (transactionItemDiscountTypeId === 1) {
        transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
          transactionItemPrice,
          peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
            100
          )
        );
      } else {
        transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
      }

      transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
      if (_transaction.taxStatus === Enums.TaxTypeId.IncludeTax) {
        if (transactionItems.vatType === Enums.ProductVatType.SevenPercent) {
          transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
            peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
            100
          );
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
        }
      } else {
        transactionItemPreVatAmount = transactionItemTotal;
      }

      let transactionItemsTemplate = {
        id: transactionItems.id,
        productTemplateId: transactionItems.productTemplateId,
        assetId: transactionItems.assetId,
        description: transactionItems.description,
        price: transactionItems.price,
        amount: transactionItems.amount,
        discount: transactionItems.discount,
        vatType: transactionItems.vatType,
        discountType: transactionItems.discountType,
        netAmount: transactionItems.netAmount,
        productTemplateCode: transactionItems.productTemplateId > 0 ? transactionItems.code : "",
        productTemplateName: "",
        stockactivityId: transactionItems.stockactivityId,
        accountId: transactionItems.accountId,
        accountCode: transactionItems.accountCode,
        accountName: transactionItems.accountName,
        accountNameEng: transactionItems.accountNameEng,
        productTemplateUuid: transactionItems.productTemplateUuid,
        uuid: transactionItems.uuid,
        isDescriptionOnly: transactionItems.isDescriptionOnly,
        accountRefId: transactionItems.accountRefId,
        accountRefTypeId: transactionItems.accountRefTypeId,
        refTransactionProductId: transactionItems.refTransactionProductId,
        refStockActivityId: transactionItems.refStockActivityId,
        creditNoteRefTransactionId: transactionItems.creditNoteRefTransactionId,
        refTransactionTypeId: transactionItems.refTransactionTypeId,
        pp30TransactionProductId: transactionItems.pp30TransactionProductId,
        isPP30Checked: transactionItems.isPP30Checked,
        isPP30Created: transactionItems.isPP30Created,
        billedAmount: transactionItems.billedAmount,
        vatAmount: transactionItems.vatAmount,
        fixAssetTemplateId: transactionItems.fixAssetTemplateId
          ? transactionItems.fixAssetTemplateId
          : transactionItems.assetTemplateId,
        isAcquisitionCost: transactionItems.isAcquisitionCost ? true : false,
        fixAssetTemplateCode: transactionItems.code,
        whtPercent: transactionItems.whtPercent,
        whtAmount: transactionItems.whtAmount,
        whtAmountType: transactionItems.whtAmountType,
        taxIncomeTypeId: transactionItems.taxIncomeTypeId,
        subTotal: transactionItems.subTotal,
        sequenceNumber: transactionItems.sequenceNumber,
        unitId: transactionItems.unitId,
        unitName: i18n.locale == Enums.LanguageType.Thai ? transactionItems.unitNameTh : transactionItems.unitNameEng,
        toCurrencyPreVatTotal: 0,
        toCurrencyZeroVatTotal: 0,
        toCurrencyVatExemptedTotal: 0,
        isUseTransactionAllocation: true,
        itemNetAmountWithAllocateDiscountForAllocation: 0,
        itemNetAmountWithAllocateDiscountTotal: 0,
        allocationList: GetAllocationListWithOutZeroPercent(transactionItems.allocationTransactionList),
        remainingQuantity: transactionItems.remainingQuantity,
        referenceQuotationItemId: transactionItems.referenceQuotationItemId,
      };

      switch (transactionItemsTemplate.vatType) {
        case Enums.ProductVatType.SevenPercent:
          transactionItemsTemplate.toCurrencyPreVatTotal = transactionItemPreVatAmount;
          break;
        case Enums.ProductVatType.ZeroPercent:
          transactionItemsTemplate.toCurrencyZeroVatTotal = transactionItemTotal;
          break;
        case Enums.ProductVatType.None:
          transactionItemsTemplate.toCurrencyVatExemptedTotal = transactionItemTotal;
          break;
      }

      if (transactionItemsTemplate.allocationList && transactionItemsTemplate.allocationList.length > 0) {
        let allocationTransactionEquals = GetAllocationTransactionEquals(
          transactionDetailTemplate.allocationList,
          transactionItemsTemplate.allocationList
        );
        transactionItemsTemplate.isUseTransactionAllocation = allocationTransactionEquals;
      }

      let transactionItemForCalculateProductTotalPrice =
        transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItems);
      let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
        transactionItemForCalculateProductTotalPrice,
        allocateDiscountPercent,
        _transaction.transactionCurrency.toCurrencyUid,
        _transaction.transactionCurrency.currencyExchangeRates,
        _transaction.transactionCurrency.currencyRatio,
        _transaction.taxStatus,
        _transaction.isCreatedTaxInvoice,
        _transaction.transactionType,
        _transaction.financeType,
        false
      );

      transactionItemsTemplate.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
      transactionItemsTemplate.itemNetAmountWithAllocateDiscountForAllocation =
        netAmountWithAllocateDiscount.FormatMoney();
      transactionDetailTemplate.transactionCurrency.amountBeforeDiscount +=
        transactionItemsTemplate.toCurrencyPreVatTotal +
        transactionItemsTemplate.toCurrencyZeroVatTotal +
        transactionItemsTemplate.toCurrencyVatExemptedTotal;
      transactionDetailTemplate.transactionItems.push(transactionItemsTemplate);
    });
  }

  transactionDetailTemplate.transactionCurrency.referenceDepositTotal = GetReferenceDepositTotalDetail(_transaction);
  transactionDetailTemplate.transactionCurrency.amountAfterDiscount = GetAmountAfterDiscountDetail(
    transactionDetailTemplate.transactionCurrency.amountBeforeDiscount,
    transactionDetailTemplate.transactionCurrency.referenceDepositTotal,
    transactionDetailTemplate.discount,
    transactionDetailTemplate.discountType
  );

  return transactionDetailTemplate;
}
async function ConvertPaymentFromPaymentModel(paymentRaw, paymentDisabled) {
  let payment = paymentHelper.GetCreateTransactionPaymentDefualt();
  if (paymentRaw && paymentRaw.paymentGroupList && paymentRaw.paymentGroupList.length > 0) {
    payment.paymentGroupList = [];
    payment.disabled = paymentDisabled;
    for (let paymentGroupRaw of paymentRaw.paymentGroupList) {
      let paymentGroupDefault = paymentHelper.GetCreateTransactionPaymentGroupDefualt();
      paymentGroupDefault.disabled = paymentDisabled;
      paymentGroupDefault.eWhtType = paymentGroupRaw.eWhtType;
      if (
        paymentGroupRaw.paymentTransactionBankAccountList &&
        paymentGroupRaw.paymentTransactionBankAccountList.length > 0
      ) {
        paymentGroupDefault.paymentTransactionBankAccountList = [];
        let count = 0;
        for (let paymentBankAccountTransactionRaw of paymentGroupRaw.paymentTransactionBankAccountList) {
          count++;
          if (count > 1) {
            paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;
            paymentGroupDefault.paymentTransactionChartAccountHidden = false;
          }
          let paymentBankAccountTransaction = paymentHelper.GetCreatePaymentTransactionBankAccountDefault();
          paymentBankAccountTransaction.bankAccountId = paymentBankAccountTransactionRaw.bankAccountId;
          paymentBankAccountTransaction.paymentAmount = paymentBankAccountTransactionRaw.paymentAmount.FormatMoney();
          paymentBankAccountTransaction.remark = paymentBankAccountTransactionRaw.remark;
          paymentBankAccountTransaction.isCheque = paymentBankAccountTransactionRaw.cheque
            ? paymentBankAccountTransactionRaw.cheque.id > 0
            : false;
          if (paymentBankAccountTransaction.isCheque) {
            paymentBankAccountTransaction.cheque.id = paymentBankAccountTransactionRaw.cheque.id;
            paymentBankAccountTransaction.cheque.chequeDate = paymentBankAccountTransactionRaw.cheque.chequeDate;
            paymentBankAccountTransaction.cheque.branchNumber = paymentBankAccountTransactionRaw.cheque.branchNumber;
            paymentBankAccountTransaction.cheque.accountNumber = paymentBankAccountTransactionRaw.cheque.accountNumber;
            paymentBankAccountTransaction.cheque.chequeBankId = paymentBankAccountTransactionRaw.cheque.chequeBankId;
            paymentBankAccountTransaction.cheque.chequeNumber = paymentBankAccountTransactionRaw.cheque.chequeNumber;
          }
          paymentGroupDefault.paymentTransactionBankAccountList.push(paymentBankAccountTransaction);
        }
      }
      if (
        paymentGroupRaw.paymentTransactionChartOfAccountList &&
        paymentGroupRaw.paymentTransactionChartOfAccountList.length > 0
      ) {
        paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;

        paymentGroupDefault.paymentTransactionChartAccountHidden = false;
        paymentGroupDefault.paymentTransactionDocumentHidden = false;

        paymentGroupDefault.paymentTransactionChartAccountActived = true;
        paymentGroupDefault.paymentTransactionChartOfAccountList = [];
        for (let paymentTransactionChartAccountRaw of paymentGroupRaw.paymentTransactionChartOfAccountList) {
          let paymentTransactionChartAccount = paymentHelper.GetCreatePaymentTransactionChartAccountDefault();
          paymentTransactionChartAccount.accountId = paymentTransactionChartAccountRaw.accountId;
          paymentTransactionChartAccount.remark = paymentTransactionChartAccountRaw.remark;
          paymentTransactionChartAccount.accountReferenceId = paymentTransactionChartAccountRaw.accountReferenceId;
          paymentTransactionChartAccount.accountReferenceTypeId =
            paymentTransactionChartAccountRaw.accountReferenceTypeId;
          if (paymentTransactionChartAccountRaw.paymentAmount < 0) {
            paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.WithDrawalAccount;
            paymentTransactionChartAccount.paymentAmount = (
              paymentTransactionChartAccountRaw.paymentAmount * -1
            ).FormatMoney();
          } else {
            paymentTransactionChartAccount.paymentAmount =
              paymentTransactionChartAccountRaw.paymentAmount.FormatMoney();
            paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.DepositeAccount;
          }
          paymentGroupDefault.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
        }

        await SetSubAccountForPaymentTransactionChartAccount(paymentGroupDefault.paymentTransactionChartOfAccountList);
      }
      if (paymentGroupRaw.paymentTransactionDocumentList && paymentGroupRaw.paymentTransactionDocumentList.length > 0) {
        paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;

        paymentGroupDefault.paymentTransactionChartAccountHidden = false;
        paymentGroupDefault.paymentTransactionDocumentHidden = false;

        paymentGroupDefault.paymentTransactionDocumentActived = true;
        paymentGroupDefault.paymentTransactionDocumentList = [];
        for (let paymentTransactionDocumentRaw of paymentGroupRaw.paymentTransactionDocumentList) {
          let paymentTransactionDocument = paymentHelper.GetCreatePaymentTransactionDocumentDefault();
          paymentTransactionDocument.transactionType = {
            value: paymentTransactionDocumentRaw.referenceTransactionType,
          };
          paymentTransactionDocument.transactionId = paymentTransactionDocumentRaw.referenceTransactionId;
          paymentTransactionDocument.transactionNumber = paymentTransactionDocumentRaw.referenceTransactionNumber;
          paymentTransactionDocument.paymentAmount = paymentTransactionDocumentRaw.paymentAmount.FormatMoney();
          paymentTransactionDocument.remark = paymentTransactionDocumentRaw.remark;
          paymentTransactionDocument.transactionIsNotAuto = true;
          paymentGroupDefault.paymentTransactionDocumentList.push(paymentTransactionDocument);
        }
      }
      if (paymentGroupRaw.eWhtType == Enums.EWhtType.Normal) {
        paymentGroupDefault.whtPayment = {
          id: paymentGroupRaw.whtPayment.id,
          isWht: paymentGroupRaw.whtPayment.whtAmount.ToNumber() > 0,
          pndTypeId: paymentGroupRaw.whtPayment.pndType,
          whtAmountTypeId: paymentGroupRaw.whtPayment.whtAmountType,
          whtAmount: paymentGroupRaw.whtPayment.whtAmount.ToNumber().FormatMoney(),
          whtDeductType: paymentGroupRaw.whtPayment.whtDeductType,
          disabled: paymentGroupDefault.disabled,
          hidden: false,
        };
      } else {
        paymentGroupDefault.eWhtData = {
          id: paymentGroupRaw.eWhtData.id,
          isWht: paymentGroupRaw.eWhtData.whtAmount.ToNumber() > 0,
          pndTypeId: paymentGroupRaw.eWhtData.pndType,
          whtAmountTypeId: paymentGroupRaw.eWhtData.whtAmountType,
          whtAmount: paymentGroupRaw.eWhtData.whtAmount.ToNumber().FormatMoney(),
          whtDeductType: paymentGroupRaw.eWhtData.whtDeductType,
          disabled: paymentGroupDefault.disabled,
          hidden: false,
        };
      }
      paymentGroupDefault.paymentGroupDate = paymentGroupRaw.paymentGroupDate;
      payment.paymentGroupList.push(paymentGroupDefault);
    }
  }
  return payment;
}
export const ConvertPaymentGroupForCreate = (paymentGroup) => {
  const paymentInOutFlowType = paymentGroup.paymentInOutFlowType;
  let _paymentGroup = {
    id: paymentGroup.id,
    isPaymentActive: paymentGroup.isPaymentActive,
    paymentTransactionBankAccountList: [],
    paymentTransactionChartOfAccountList: [],
    paymentTransactionDocumentList: [],

    whtPayment: {
      id: paymentGroup.whtPayment.id,
      isWht: paymentGroup.whtPayment.isWht,
      whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
      whtAmount: paymentGroup.whtPayment.whtAmount.ToNumber(),
      pndType: paymentGroup.whtPayment.pndTypeId,
      whtDeductType: paymentGroup.whtPayment.whtDeductType,
    },
    eWhtData: null,
    eWhtType: paymentGroup.eWhtType,
    paymentGroupDate: paymentGroup.paymentGroupDate,
  };
  if (paymentInOutFlowType == Enums.PaymentInOutFlowType.CashIn) {
    _paymentGroup.eWhtData = {
      id: paymentGroup.whtPayment.id,
      isWht: paymentGroup.whtPayment.isWht,
      whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
      whtAmount: paymentGroup.whtPayment.whtAmount.ToNumber(),
      pndType: paymentGroup.whtPayment.pndTypeId,
      whtDeductType: paymentGroup.whtPayment.whtDeductType,
    };
  } else {
    _paymentGroup.eWhtData = {
      id: paymentGroup.eWhtData.id,
      isWht: paymentGroup.eWhtData.isWht,
      whtAmountType: paymentGroup.eWhtData.whtAmountTypeId,
      whtAmount: paymentGroup.eWhtData.whtAmount.ToNumber(),
      pndType: paymentGroup.eWhtData.pndTypeId,
      whtDeductType: paymentGroup.eWhtData.whtDeductType,
    };
  }
  if (_paymentGroup.isPaymentActive) {
    if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
      for (let paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
        let _paymentTransactionBankAccount = {
          id: paymentTransactionBankAccount.id,
          bankAccountId:
            paymentTransactionBankAccount.bankAccountId > 0 ? paymentTransactionBankAccount.bankAccountId : 0,
          bankAccountCode: paymentTransactionBankAccount.bankAccountCode,
          isCheque: paymentTransactionBankAccount.isCheque,
          cheque: paymentTransactionBankAccount.isCheque
            ? {
                id: paymentTransactionBankAccount.cheque.id,
                chequeNumber: paymentTransactionBankAccount.cheque.chequeNumber,
                chequeDate: paymentTransactionBankAccount.cheque.chequeDate,
                branchNumber: paymentTransactionBankAccount.cheque.branchNumber,
                accountNumber: paymentTransactionBankAccount.cheque.accountNumber,
                chequeBankId: paymentTransactionBankAccount.cheque.chequeBankId,
                createPaymentDate: paymentTransactionBankAccount.cheque.createPaymentDate,
              }
            : {},
          paymentAmount: paymentTransactionBankAccount.paymentAmount,
          remark: paymentTransactionBankAccount.remark,
        };
        _paymentGroup.paymentTransactionBankAccountList.push(_paymentTransactionBankAccount);
      }
    }
    if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
      for (let paymentTransactionChartAccount of paymentGroup.paymentTransactionChartOfAccountList) {
        let _paymentTransactionChartAccount = {
          id: paymentTransactionChartAccount.id,
          accountId: paymentTransactionChartAccount.accountId,
          accountCode: paymentTransactionChartAccount.accountCode,
          accountReferenceId: paymentTransactionChartAccount.accountReferenceId,
          accountReferenceTypeId: paymentTransactionChartAccount.accountReferenceTypeId,
          paymentAmount:
            (paymentTransactionChartAccount.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount ? -1 : 1) *
            paymentTransactionChartAccount.paymentAmount.ToNumber(),
          remark: paymentTransactionChartAccount.remark,
        };
        _paymentGroup.paymentTransactionChartOfAccountList.push(_paymentTransactionChartAccount);
      }
    }
    if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
      for (let paymentTransactionDocument of paymentGroup.paymentTransactionDocumentList) {
        let _paymentTransactionDocument = {
          id: paymentTransactionDocument.id,
          referenceTransactionId: paymentTransactionDocument.transactionId,
          referenceTransactionType: paymentTransactionDocument.transactionType.value,
          referenceTransactionNumber: paymentTransactionDocument.transactionNumber,
          paymentAmount: paymentTransactionDocument.paymentAmount.ToNumber(),
          paymentInOutFlowType: paymentTransactionDocument.paymentInOutFlowType,
          remark: paymentTransactionDocument.remark,
        };
        _paymentGroup.paymentTransactionDocumentList.push(_paymentTransactionDocument);
      }
    }
  }

  return _paymentGroup;
};
function ConvertPaymentForCreate(paymentRaw) {
  let payment = {
    paymentGroupList: [],
  };
  if (paymentRaw.paymentGroupList) {
    for (let paymentGroup of paymentRaw.paymentGroupList) {
      const _paymentGroup = ConvertPaymentGroupForCreate(paymentGroup);
      payment.paymentGroupList.push(_paymentGroup);
    }
  }
  return payment;
}
export const GetPaymentGroupForCreate = async (paymentGroupRaw, paymentDisabled) => {
  const paymentGroupDefault = paymentHelper.GetCreateTransactionPaymentGroupDefualt();
  paymentGroupDefault.disabled = paymentDisabled;
  if (paymentGroupRaw) {
    if (
      paymentGroupRaw.paymentTransactionBankAccountList &&
      paymentGroupRaw.paymentTransactionBankAccountList.length > 0
    ) {
      paymentGroupDefault.paymentTransactionBankAccountList = [];
      let count = 0;
      for (const paymentBankAccountTransactionRaw of paymentGroupRaw.paymentTransactionBankAccountList) {
        count++;
        if (count > 1) {
          paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;
          paymentGroupDefault.paymentTransactionChartAccountHidden = false;
        }
        const paymentBankAccountTransaction = paymentHelper.GetCreatePaymentTransactionBankAccountDefault();
        paymentBankAccountTransaction.id = paymentBankAccountTransactionRaw.id;
        paymentBankAccountTransaction.bankAccountId = paymentBankAccountTransactionRaw.bankAccountId;
        paymentBankAccountTransaction.paymentAmount = paymentBankAccountTransactionRaw.paymentAmount.FormatMoney();
        paymentBankAccountTransaction.remark = paymentBankAccountTransactionRaw.remark;
        paymentBankAccountTransaction.isCheque = paymentBankAccountTransactionRaw.isCheque;

        if (paymentBankAccountTransaction.isCheque) {
          paymentBankAccountTransaction.cheque.id = paymentBankAccountTransactionRaw.cheque.id;
          paymentBankAccountTransaction.cheque.chequeDate = paymentBankAccountTransactionRaw.cheque.chequeDate;
          paymentBankAccountTransaction.cheque.branchNumber = paymentBankAccountTransactionRaw.cheque.branchNumber;
          paymentBankAccountTransaction.cheque.accountNumber = paymentBankAccountTransactionRaw.cheque.accountNumber;
          paymentBankAccountTransaction.cheque.chequeBankId = paymentBankAccountTransactionRaw.cheque.chequeBankId;
          paymentBankAccountTransaction.cheque.chequeNumber = paymentBankAccountTransactionRaw.cheque.chequeNumber;
        }
        paymentGroupDefault.paymentTransactionBankAccountList.push(paymentBankAccountTransaction);
      }
    } else {
      paymentGroupDefault.paymentTransactionBankAccountActived = false;
    }

    if (
      paymentGroupRaw.paymentTransactionChartOfAccountList &&
      paymentGroupRaw.paymentTransactionChartOfAccountList.length > 0
    ) {
      paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;

      paymentGroupDefault.paymentTransactionChartAccountHidden = false;
      paymentGroupDefault.paymentTransactionDocumentHidden = false;

      paymentGroupDefault.paymentTransactionChartAccountActived = true;
      paymentGroupDefault.paymentTransactionChartOfAccountList = [];
      for (const paymentTransactionChartAccountRaw of paymentGroupRaw.paymentTransactionChartOfAccountList) {
        const paymentTransactionChartAccount = paymentHelper.GetCreatePaymentTransactionChartAccountDefault();
        paymentTransactionChartAccount.id = paymentTransactionChartAccountRaw.id;
        paymentTransactionChartAccount.accountId = paymentTransactionChartAccountRaw.accountId;
        paymentTransactionChartAccount.remark = paymentTransactionChartAccountRaw.remark;
        paymentTransactionChartAccount.accountReferenceId = paymentTransactionChartAccountRaw.accountReferenceId;
        paymentTransactionChartAccount.accountReferenceTypeId =
          paymentTransactionChartAccountRaw.accountReferenceTypeId;
        if (paymentTransactionChartAccountRaw.paymentAmount < 0) {
          paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.WithDrawalAccount;
          paymentTransactionChartAccount.paymentAmount = (
            paymentTransactionChartAccountRaw.paymentAmount * -1
          ).FormatMoney();
        } else {
          paymentTransactionChartAccount.paymentAmount = paymentTransactionChartAccountRaw.paymentAmount.FormatMoney();
          paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.DepositeAccount;
        }
        paymentGroupDefault.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
      }

      await SetSubAccountForPaymentTransactionChartAccount(paymentGroupDefault.paymentTransactionChartOfAccountList);
    }

    if (paymentGroupRaw.paymentTransactionReferenceList && paymentGroupRaw.paymentTransactionReferenceList.length > 0) {
      paymentGroupDefault.paymentOption = Enums.PaymentOption.Advance;

      paymentGroupDefault.paymentTransactionChartAccountHidden = false;
      paymentGroupDefault.paymentTransactionDocumentHidden = false;

      paymentGroupDefault.paymentTransactionDocumentActived = true;
      paymentGroupDefault.paymentTransactionDocumentList = [];
      for (const paymentTransactionReferenceRaw of paymentGroupRaw.paymentTransactionReferenceList) {
        const paymentTransactionDocument = paymentHelper.GetCreatePaymentTransactionDocumentDefault();
        paymentTransactionDocument.id = paymentTransactionReferenceRaw.id;
        paymentTransactionDocument.transactionType = {
          value: paymentTransactionReferenceRaw.referenceTransactionType,
        };
        paymentTransactionDocument.transactionId = paymentTransactionReferenceRaw.referenceTransactionId;
        paymentTransactionDocument.transactionNumber = paymentTransactionReferenceRaw.paymentReferenceDocumentDetail
          ? paymentTransactionReferenceRaw.paymentReferenceDocumentDetail.number
          : "";
        paymentTransactionDocument.paymentAmount = paymentTransactionReferenceRaw.paymentAmount.FormatMoney();
        paymentTransactionDocument.remark = paymentTransactionReferenceRaw.remark;
        paymentTransactionDocument.transactionIsNotAuto = true;

        paymentGroupDefault.paymentTransactionDocumentList.push(paymentTransactionDocument);
      }
    }
    if (paymentGroupRaw.eWhtType == Enums.EWhtType.Normal) {
      paymentGroupDefault.whtPayment = {
        id: paymentGroupRaw.wht.id,
        isWht: paymentGroupRaw.wht.whtAmount.ToNumber() > 0,
        pndTypeId: paymentGroupRaw.wht.pndType,
        whtAmountTypeId: paymentGroupRaw.wht.whtAmountType,
        whtAmount: paymentGroupRaw.wht.whtAmount.ToNumber().FormatMoney(),
        whtDeductType: paymentGroupRaw.wht.whtDeductType,
        disabled: paymentGroupDefault.disabled,
        hidden: false,
      };
    } else {
      paymentGroupDefault.eWhtData = {
        id: paymentGroupRaw.eWhtData.id,
        isWht: paymentGroupRaw.eWhtData.whtAmount.ToNumber() > 0,
        pndTypeId: paymentGroupRaw.eWhtData.pndType,
        whtAmountTypeId: paymentGroupRaw.eWhtData.whtAmountType,
        whtAmount: paymentGroupRaw.eWhtData.whtAmount.ToNumber().FormatMoney(),
        whtDeductType: paymentGroupRaw.eWhtData.whtDeductType,
        disabled: paymentGroupDefault.disabled,
        hidden: false,
      };
    }

    paymentGroupDefault.eWhtType = paymentGroupRaw.eWhtType;

    paymentGroupDefault.paymentGroupDate = paymentGroupRaw.date;
    paymentGroupDefault.id = paymentGroupRaw.id;
  }
  return paymentGroupDefault;
};
export const ConvertPaymentGroupListForDetailForReceiptCreate = async (paymentGroupList) => {
  const isDisabled = paymentGroupList && paymentGroupList.length > 0;
  return await ConvertPaymentGroupListForDetail(paymentGroupList, isDisabled);
};
export const ConvertPaymentGroupListForDetailForReceiptEdit = async (receiptDetail, paymentGroupList) => {
  const isDisabled =
    (receiptDetail.referenceType == Enums.ReceiptReferenceType.Invoice ||
      receiptDetail.referenceType == Enums.ReceiptReferenceType.BillingNote) &&
    receiptDetail.referencePaymentGroupId != 0;
  return await ConvertPaymentGroupListForDetail(paymentGroupList, isDisabled);
};
export const ConvertPaymentGroupListForDetail = async (paymentGroupList, isDisabled) => {
  const payment = paymentHelper.GetCreateTransactionPaymentDefualt();
  if (paymentGroupList && paymentGroupList.length > 0) {
    payment.paymentGroupList = [];
    payment.disabled = isDisabled;
    for (let paymentGroupRaw of paymentGroupList) {
      payment.paymentGroupList.push(await GetPaymentGroupForCreate(paymentGroupRaw, isDisabled));
    }
  }
  return payment;
};
export const ConvertPaymentGroupForDetail = async (paymentGroupRaw, paymentDisabled) => {
  const payment = paymentHelper.GetCreateTransactionPaymentDefualt();
  payment.paymentGroupList = [];
  payment.disabled = paymentDisabled;
  payment.paymentGroupList.push(await GetPaymentGroupForCreate(paymentGroupRaw, paymentDisabled));
  return payment;
};

export const ConvertPaymentGroupForCreateModel = (paymentRaw, financeType) => {
  const payment = {
    date: null,
    paymentTransactionBankAccountList: [],
    paymentTransactionChartOfAccountList: [],
    paymentTransactionReferenceList: [],
    wht: ConvertPaymentWhtForCreateModel(null),
    eWhtData: ConvertPaymentWhtForCreateModel(null),
    eWhtType: Enums.EWhtType.Normal,
  };

  if (paymentRaw.paymentGroupList) {
    for (const paymentGroup of paymentRaw.paymentGroupList) {
      const paymentInOutFlowType = paymentGroup.paymentInOutFlowType;
      payment.date = paymentGroup.paymentGroupDate;
      if (paymentGroup.isPaymentActive) {
        if (
          paymentInOutFlowType == Enums.PaymentInOutFlowType.CashIn ||
          (paymentInOutFlowType == Enums.PaymentInOutFlowType.CashOut && paymentGroup.eWhtType == Enums.EWhtType.Normal)
        ) {
          payment.wht = ConvertPaymentWhtForCreateModel(paymentGroup.whtPayment);
        }
        payment.eWhtData =
          paymentInOutFlowType == Enums.PaymentInOutFlowType.CashIn
            ? ConvertPaymentWhtForCreateModel(paymentGroup.whtPayment)
            : ConvertPaymentWhtForCreateModel(paymentGroup.eWhtData);
        payment.eWhtType = paymentGroup.eWhtType;
        if (
          paymentGroup.paymentTransactionBankAccountList &&
          paymentGroup.paymentTransactionBankAccountList.length > 0
        ) {
          for (const paymentTransactionBankAccountItem of paymentGroup.paymentTransactionBankAccountList) {
            const paymentTransactionBankAccount = ConvertPaymentTransactionBankAccountForCreateModel(
              paymentTransactionBankAccountItem
            );
            payment.paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
          }
        }

        if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
          for (const paymentTransactionChartAccountItem of paymentGroup.paymentTransactionChartOfAccountList) {
            const paymentTransactionChartAccount = ConvertPaymentTransactionChartAccountForCreateModel(
              paymentTransactionChartAccountItem
            );
            payment.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
          }
        }

        if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
          for (const paymentTransactionDocumentItem of paymentGroup.paymentTransactionDocumentList) {
            const paymentTransactionDocument =
              ConvertPaymentTransactionDocumentForCreateModel(paymentTransactionDocumentItem);
            payment.paymentTransactionReferenceList.push(paymentTransactionDocument);
          }
        }
      }
    }
  }

  return payment;
};
export const ConvertPaymentWhtForCreateModel = (whtPaymentRawData) => {
  const wht = {
    whtAmount: 0,
    whtAmountType: 0,
    pndType: 0,
    whtDeductType: 0,
  };
  if (whtPaymentRawData) {
    wht.whtAmount = whtPaymentRawData.whtAmount;
    wht.whtAmountType = whtPaymentRawData.whtAmountTypeId;
    wht.pndType = whtPaymentRawData.pndTypeId;
    wht.whtDeductType = whtPaymentRawData.whtDeductType;
  }
  return wht;
};

export const ConvertPaymentTransactionBankAccountForCreateModel = (paymentTransactionBankAccountRawData) => {
  const paymentTransactionBankAccount = {
    remark: "",
    paymentAmount: 0,
    isCheque: false,
    cheque: null,
    bankAccountId: 0,
  };
  if (
    paymentTransactionBankAccountRawData &&
    (paymentTransactionBankAccountRawData.bankAccountId > 0 || paymentTransactionBankAccountRawData.isCheque)
  ) {
    paymentTransactionBankAccount.remark = paymentTransactionBankAccountRawData.remark;
    paymentTransactionBankAccount.paymentAmount = paymentTransactionBankAccountRawData.paymentAmount;
    paymentTransactionBankAccount.isCheque = paymentTransactionBankAccountRawData.isCheque;
    paymentTransactionBankAccount.cheque = ConvertPaymentChequeCreateForCreateModel(
      paymentTransactionBankAccountRawData.isCheque,
      paymentTransactionBankAccountRawData.cheque
    );
    if (paymentTransactionBankAccountRawData.bankAccountId > 0) {
      paymentTransactionBankAccount.bankAccountId = paymentTransactionBankAccountRawData.bankAccountId;
    }
  }
  return paymentTransactionBankAccount;
};
export const ConvertPaymentChequeCreateForCreateModel = (isCheque, chequeRawData) => {
  const cheque = {
    chequeNumber: "",
    branchNumber: "",
    accountNumber: "",
    chequeDate: new Date(),
    chequeBankId: 0,
  };
  if (isCheque && chequeRawData) {
    cheque.chequeNumber = chequeRawData.chequeNumber;
    cheque.branchNumber = chequeRawData.branchNumber;
    cheque.accountNumber = chequeRawData.accountNumber;
    cheque.chequeDate = chequeRawData.chequeDate;
    cheque.chequeBankId = chequeRawData.chequeBankId;
  }
  return cheque;
};
export const ConvertPaymentTransactionChartAccountForCreateModel = (paymentTransactionChartAccountRawData) => {
  const paymentTransactionChartAccount = {
    accountId: 0,
    accountReferenceId: 0,
    accountReferenceTypeId: 0,
    remark: "",
    paymentAmount: 0,
  };
  if (paymentTransactionChartAccountRawData && paymentTransactionChartAccountRawData.accountId > 0) {
    paymentTransactionChartAccount.accountId = paymentTransactionChartAccountRawData.accountId;
    paymentTransactionChartAccount.accountReferenceId = paymentTransactionChartAccountRawData.accountReferenceId;
    paymentTransactionChartAccount.accountReferenceTypeId =
      paymentTransactionChartAccountRawData.accountReferenceTypeId;
    paymentTransactionChartAccount.remark = paymentTransactionChartAccountRawData.remark;
    paymentTransactionChartAccount.paymentAmount =
      (paymentTransactionChartAccountRawData.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount ? -1 : 1) *
      paymentTransactionChartAccountRawData.paymentAmount.ToNumber();
  }
  return paymentTransactionChartAccount;
};
export const ConvertPaymentTransactionDocumentForCreateModel = (paymentTransactionDocumentRawData) => {
  const paymentTransactionDocument = {
    referenceTransactionId: 0,
    referenceTransactionType: 0,
    remark: "",
    paymentAmount: 0,
  };
  if (paymentTransactionDocumentRawData && paymentTransactionDocumentRawData.transactionId > 0) {
    paymentTransactionDocument.referenceTransactionId = paymentTransactionDocumentRawData.transactionId;
    paymentTransactionDocument.referenceTransactionType = paymentTransactionDocumentRawData.transactionType.value;
    paymentTransactionDocument.remark = paymentTransactionDocumentRawData.remark;
    paymentTransactionDocument.paymentAmount = paymentTransactionDocumentRawData.paymentAmount;
  }
  return paymentTransactionDocument;
};

export const ConvertToWhtPaymentGroupDetail = (paymentGroupRaw) => {
  const whtPayment = {
    id: 0,
    isWht: false,
    whtAmountType: 0,
    whtAmount: 0,
    pndType: 0,
    pndId: 0,
    isFiledFromPeakTax: false,
    isFetchedDataToPeakTax: false,
  };

  if (paymentGroupRaw && paymentGroupRaw.wht) {
    whtPayment.id = paymentGroupRaw.wht.id;
    whtPayment.isWht = paymentGroupRaw.wht.whtAmount !== 0;
    whtPayment.whtAmountType = paymentGroupRaw.wht.whtAmountType;
    whtPayment.whtAmount = paymentGroupRaw.wht.whtAmount;
    whtPayment.pndType = paymentGroupRaw.wht.pndType;
    whtPayment.pndId = paymentGroupRaw.wht.pndId;
    whtPayment.isFiledFromPeakTax = paymentGroupRaw.wht.isFiledFromPeakTax;
    whtPayment.isFetchedDataToPeakTax = paymentGroupRaw.wht.isFetchedDataToPeakTax;
  }
  return whtPayment;
};

export const ConvertToEWhtPaymentGroupDetail = (paymentGroupRaw) => {
  const whtPayment = {
    id: 0,
    isWht: false,
    whtAmountType: 0,
    whtAmount: 0,
    pndType: 0,
    pndId: 0,
    isFiledFromPeakTax: false,
    isFetchedDataToPeakTax: false,
  };

  if (paymentGroupRaw && paymentGroupRaw.eWhtData) {
    whtPayment.id = paymentGroupRaw.eWhtData.id;
    whtPayment.isWht = paymentGroupRaw.eWhtData.whtAmount !== 0;
    whtPayment.whtAmountType = paymentGroupRaw.eWhtData.whtAmountType;
    whtPayment.whtAmount = paymentGroupRaw.eWhtData.whtAmount;
    whtPayment.pndType = paymentGroupRaw.eWhtData.pndType;
    whtPayment.pndId = paymentGroupRaw.eWhtData.pndId;
    whtPayment.isFiledFromPeakTax = paymentGroupRaw.eWhtData.isFiledFromPeakTax;
    whtPayment.isFetchedDataToPeakTax = paymentGroupRaw.eWhtData.isFetchedDataToPeakTax;
  }
  return whtPayment;
};

export const ConvertToReferenceJournalListDetail = (paymentGroupRaw) => {
  const referenceJournalList = [];
  if (paymentGroupRaw.referenceJournalList && paymentGroupRaw.referenceJournalList.length > 0) {
    for (const referenceJournalRaw of paymentGroupRaw.referenceJournalList) {
      referenceJournalList.push({
        journalId: referenceJournalRaw.journalId,
        journalNumber: referenceJournalRaw.journalNumber,
        isDeleted: referenceJournalRaw.isDeleted,
        journalLockStatus: referenceJournalRaw.journalLockStatus,
      });
    }
  }
  return referenceJournalList;
};

export const ConvertToPaymentTransactionBankAccountListDetail = (paymentGroupRaw) => {
  const paymentTransactionBankAccountList = [];
  let totalPaidPaymentWithOutChartOfAccount = 0;
  if (
    paymentGroupRaw.paymentTransactionBankAccountList &&
    paymentGroupRaw.paymentTransactionBankAccountList.length > 0
  ) {
    for (const paymentTransactionBankAccountRaw of paymentGroupRaw.paymentTransactionBankAccountList) {
      const paymentTransactionBankAccount = {
        id: paymentTransactionBankAccountRaw.id,
        bankAccountId: paymentTransactionBankAccountRaw.bankAccountId,
        bankAccountCode: "",
        isCheque: paymentTransactionBankAccountRaw.isCheque,
        cheque: paymentTransactionBankAccountRaw.isCheque
          ? {
              chequeId: paymentTransactionBankAccountRaw.cheque.id,
            }
          : {},
        paymentAmount: paymentTransactionBankAccountRaw.paymentAmount,
        remark: paymentTransactionBankAccountRaw.remark,
        isReconciled: paymentTransactionBankAccountRaw.isReconciled,
      };
      totalPaidPaymentWithOutChartOfAccount += paymentTransactionBankAccount.paymentAmount;
      paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
    }
  }
  return { paymentTransactionBankAccountList, totalPaidPaymentWithOutChartOfAccount };
};

export const ConvertToPaymentTransactionChartOfAccountListDetail = async (paymentGroupRaw) => {
  const paymentTransactionChartOfAccountList = [];
  let paymentGroupTotal = 0;

  if (
    paymentGroupRaw.paymentTransactionChartOfAccountList &&
    paymentGroupRaw.paymentTransactionChartOfAccountList.length > 0
  ) {
    for (const paymentTransactionChartAccountRaw of paymentGroupRaw.paymentTransactionChartOfAccountList) {
      const paymentTransactionChartAccount = {
        id: paymentTransactionChartAccountRaw.id,
        accountId: paymentTransactionChartAccountRaw.accountId,
        accountCode: "",
        accountReferenceId: paymentTransactionChartAccountRaw.accountReferenceId,
        accountReferenceTypeId: paymentTransactionChartAccountRaw.accountReferenceTypeId,
        accountReferenceName: "",
        accountReferenceCode: "",
        paymentAmount: paymentTransactionChartAccountRaw.paymentAmount,
        remark: paymentTransactionChartAccountRaw.remark,
      };
      paymentGroupTotal += paymentTransactionChartAccount.paymentAmount;
      paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
    }
    await SetSubAccountForPaymentTransactionChartAccount(paymentTransactionChartOfAccountList);
  }
  return { paymentTransactionChartOfAccountList, paymentGroupTotal };
};

export const ConvertToPaymentTransactionReferenceListDetail = (paymentGroupRaw) => {
  const paymentTransactionDocumentList = [];
  let paymentGroupTotal = 0;

  if (paymentGroupRaw.paymentTransactionReferenceList && paymentGroupRaw.paymentTransactionReferenceList.length > 0) {
    for (const paymentTransactionReferenceRaw of paymentGroupRaw.paymentTransactionReferenceList) {
      const paymentTransactionDocument = {
        id: paymentTransactionReferenceRaw.id,
        transactionId: paymentTransactionReferenceRaw.referenceTransactionId,
        transactionType: paymentTransactionReferenceRaw.referenceTransactionType,
        transactionNumber: paymentTransactionReferenceRaw.paymentReferenceDocumentDetail.number,
        transactionFinanceType: paymentTransactionReferenceRaw.paymentReferenceDocumentDetail.financeType,
        transactionExpenseType: paymentTransactionReferenceRaw.paymentReferenceDocumentDetail.transactionItemType,
        paymentAmount: paymentTransactionReferenceRaw.paymentAmount,
        remark: paymentTransactionReferenceRaw.remark,
      };
      paymentGroupTotal += paymentTransactionDocument.paymentAmount;
      paymentTransactionDocumentList.push(paymentTransactionDocument);
    }
  }
  return { paymentTransactionDocumentList, paymentGroupTotal };
};

export const ConvertToPaymentGroupListAndReferenceJournalDetail = async (
  paymentGroupListRaw,
  transactionId,
  transactionType
) => {
  let payment = {
    transactionId: transactionId,
    transactionType: transactionType,
    paymentGroupList: [],
  };
  if (paymentGroupListRaw && paymentGroupListRaw.length > 0) {
    for (const paymentGroupRaw of paymentGroupListRaw) {
      const paymentGroup = {
        id: paymentGroupRaw.id,
        paymentTransactionBankAccountList: [],
        paymentTransactionChartOfAccountList: [],
        paymentTransactionDocumentList: [],
        whtPayment: ConvertToWhtPaymentGroupDetail(paymentGroupRaw),
        eWhtData: ConvertToEWhtPaymentGroupDetail(paymentGroupRaw),
        eWhtType: paymentGroupRaw.eWhtType,
        paymentGroupDate: paymentGroupRaw.date,
        isApproved: paymentGroupRaw.isApproved,
        transactionId: paymentGroupRaw.transactionId,
        transactionType: paymentGroupRaw.transactionType,
        transactionNumber: paymentGroupRaw.transactionNumber,
        referenceTransactionId: paymentGroupRaw.referenceTransactionId,
        referenceTransactionType: paymentGroupRaw.referenceTransactionType,
        referenceTransactionNumber: paymentGroupRaw.referenceTransactionNumber,
        referenceJournalList: [],
        paymentGroupTotal: 0,
        totalPaidPaymentWithOutChartOfAccount: 0,
      };
      paymentGroup.totalPaidPaymentWithOutChartOfAccount += paymentGroupRaw.wht.whtAmount;
      paymentGroup.referenceJournalList = ConvertToReferenceJournalListDetail(paymentGroupRaw);

      const outputPaymentTransactionBankAccount = ConvertToPaymentTransactionBankAccountListDetail(paymentGroupRaw);
      paymentGroup.totalPaidPaymentWithOutChartOfAccount +=
        outputPaymentTransactionBankAccount.totalPaidPaymentWithOutChartOfAccount;
      paymentGroup.paymentTransactionBankAccountList =
        outputPaymentTransactionBankAccount.paymentTransactionBankAccountList;

      const outputPaymentTransactionChartOfAccount = await ConvertToPaymentTransactionChartOfAccountListDetail(
        paymentGroupRaw
      );
      paymentGroup.paymentGroupTotal += outputPaymentTransactionChartOfAccount.paymentGroupTotal;
      paymentGroup.paymentTransactionChartOfAccountList =
        outputPaymentTransactionChartOfAccount.paymentTransactionChartOfAccountList;

      const outputPaymentTransactionReference = ConvertToPaymentTransactionReferenceListDetail(paymentGroupRaw);
      paymentGroup.paymentGroupTotal += outputPaymentTransactionReference.paymentGroupTotal;
      paymentGroup.paymentTransactionDocumentList = outputPaymentTransactionReference.paymentTransactionDocumentList;

      paymentGroup.paymentGroupTotal += paymentGroup.totalPaidPaymentWithOutChartOfAccount;
      payment.paymentGroupList.push(paymentGroup);
    }
  }

  return payment;
};

export const ConvertToReconcileTransactionInvoiceReceiptDetail = (referenceRawList, transactionId, transactionType) => {
  const reconcileTransactionDetail = {
    transactionId: transactionId,
    transactionType: transactionType,
    referenceList: [],
  };
  if (referenceRawList && referenceRawList.length > 0) {
    for (const referenceRaw of referenceRawList) {
      const referenceItem = {
        referenceId: referenceRaw.invoiceReceiptId,
        transactionType: Enums.TransactionType.InvoiceReceipt,
        referenceTransactionNumber: "",
        fromCurrencyWHTTotal: referenceRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceRaw.toCurrencySubTotalForcalculateWHT,
        referencedJournalList: [],
      };
      reconcileTransactionDetail.referenceList.push(referenceItem);
    }
  }
  return reconcileTransactionDetail;
};

export const ConvertToReconcileTransactionGoodsReceiptDetail = (referenceRawList, transactionId, transactionType) => {
  const reconcileTransactionDetail = {
    transactionId: transactionId,
    transactionType: transactionType,
    referenceList: [],
  };

  if (referenceRawList && referenceRawList.length > 0) {
    for (const referenceRaw of referenceRawList) {
      const referenceItem = {
        referenceId: referenceRaw.goodsReceiptId,
        transactionType: Enums.TransactionType.GoodsReceipt,
        referenceTransactionNumber: "",
        fromCurrencyWHTTotal: referenceRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceRaw.toCurrencySubTotalForcalculateWHT,
        referencedJournalList: [],
      };
      reconcileTransactionDetail.referenceList.push(referenceItem);
    }
  }

  return reconcileTransactionDetail;
};

export const ConvertToDepositDeductionDetail = (referenceRawList, transactionId) => {
  const depositDeductionDetail = {
    transactionId: transactionId,
    referenceList: [],
  };

  if (referenceRawList && referenceRawList.length > 0) {
    for (const referenceRaw of referenceRawList) {
      const referenceItem = {
        referenceTransactionNumber: "",
        referenceTransactionIssueDate: null,
        referencedJournalList: [],
        depositId: referenceRaw.depositId,
        referenceId: referenceRaw.referenceTransactionId,
        transactionType: referenceRaw.referenceTransactionType,
        fromCurrencyWHTTotal: referenceRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceRaw.toCurrencySubTotalForcalculateWHT,
      };
      depositDeductionDetail.referenceList.push(referenceItem);
    }
  }

  return depositDeductionDetail;
};

async function ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType) {
  let payment = {
    transactionId: transactionId,
    transactionType: transactionType,
    paymentGroupList: [],
  };
  if (paymentRaw.paymentGroupList) {
    for (let paymentGroup of paymentRaw.paymentGroupList) {
      let _paymentGroup = {
        id: paymentGroup.id,
        paymentTransactionBankAccountList: [],
        paymentTransactionChartOfAccountList: [],
        paymentTransactionDocumentList: [],
        whtPayment: {
          id: paymentGroup.whtPayment.id,
          isWht: paymentGroup.whtPayment.isWht,
          whtAmountType: paymentGroup.whtPayment.whtAmountTypeId,
          whtAmount: paymentGroup.whtPayment.whtAmount,
          pndType: paymentGroup.whtPayment.pndType,
          pndId: paymentGroup.whtPayment.pndId,
          isFiledFromPeakTax: paymentGroup.whtPayment.isFiledFromPeakTax,
          isFetchedDataToPeakTax: paymentGroup.whtPayment.isFetchedDataToPeakTax,
        },
        eWhtData: paymentGroup.eWhtData
          ? {
              id: paymentGroup.eWhtData.id,
              isWht: paymentGroup.eWhtData.isWht,
              whtAmountType: paymentGroup.eWhtData.whtAmountTypeId,
              whtAmount: paymentGroup.eWhtData.whtAmount,
              pndType: paymentGroup.eWhtData.pndType,
              pndId: paymentGroup.eWhtData.pndId,
              isFiledFromPeakTax: paymentGroup.eWhtData.isFiledFromPeakTax,
              isFetchedDataToPeakTax: paymentGroup.eWhtData.isFetchedDataToPeakTax,
            }
          : null,
        eWhtType: paymentGroup.eWhtType,
        paymentGroupDate: paymentGroup.paymentGroupDate,
        isApproved: paymentGroup.isApproved,
        transactionId: paymentGroup.transactionId,
        transactionType: paymentGroup.transactionType,
        transactionNumber: paymentGroup.transactionNumber,
        referenceTransactionId: paymentGroup.referenceTransactionId,
        referenceTransactionType: paymentGroup.referenceTransactionType,
        referenceTransactionNumber: paymentGroup.referenceTransactionNumber,
        referenceJournalList: [],
        paymentGroupTotal: 0,
        totalPaidPaymentWithOutChartOfAccount: 0,
      };
      _paymentGroup.totalPaidPaymentWithOutChartOfAccount += paymentGroup.whtPayment.whtAmount;
      if (paymentGroup.referenceJournalList && paymentGroup.referenceJournalList.length > 0) {
        for (let referenceJournal of paymentGroup.referenceJournalList) {
          _paymentGroup.referenceJournalList.push({
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
        for (let paymentTransactionBankAccount of paymentGroup.paymentTransactionBankAccountList) {
          let _paymentTransactionBankAccount = {
            id: paymentTransactionBankAccount.id,
            bankAccountId: paymentTransactionBankAccount.bankAccountId,
            bankAccountCode: paymentTransactionBankAccount.bankAccountCode,
            isCheque: paymentTransactionBankAccount.isCheque,
            cheque: paymentTransactionBankAccount.isCheque
              ? {
                  chequeId: paymentTransactionBankAccount.cheque.id,
                }
              : {},
            paymentAmount: paymentTransactionBankAccount.paymentAmount,
            remark: paymentTransactionBankAccount.remark,
            isReconciled: paymentTransactionBankAccount.isReconciled,
          };
          _paymentGroup.totalPaidPaymentWithOutChartOfAccount += _paymentTransactionBankAccount.paymentAmount;
          _paymentGroup.paymentTransactionBankAccountList.push(_paymentTransactionBankAccount);
        }
      }
      if (
        paymentGroup.paymentTransactionChartOfAccountList &&
        paymentGroup.paymentTransactionChartOfAccountList.length > 0
      ) {
        for (let paymentTransactionChartAccount of paymentGroup.paymentTransactionChartOfAccountList) {
          let _paymentTransactionChartAccount = {
            id: paymentTransactionChartAccount.id,
            accountId: paymentTransactionChartAccount.accountId,
            accountCode: paymentTransactionChartAccount.accountCode,
            accountReferenceId: paymentTransactionChartAccount.accountReferenceId,
            accountReferenceTypeId: paymentTransactionChartAccount.accountReferenceTypeId,
            accountReferenceName: "",
            accountReferenceCode: "",
            paymentAmount: paymentTransactionChartAccount.paymentAmount.ToNumber(),
            remark: paymentTransactionChartAccount.remark,
          };
          _paymentGroup.paymentGroupTotal += _paymentTransactionChartAccount.paymentAmount;
          _paymentGroup.paymentTransactionChartOfAccountList.push(_paymentTransactionChartAccount);
        }
        await SetSubAccountForPaymentTransactionChartAccount(_paymentGroup.paymentTransactionChartOfAccountList);
      }
      if (paymentGroup.paymentTransactionDocumentList && paymentGroup.paymentTransactionDocumentList.length > 0) {
        for (let paymentTransactionDocument of paymentGroup.paymentTransactionDocumentList) {
          let _paymentTransactionDocument = {
            id: paymentTransactionDocument.id,
            transactionId: paymentTransactionDocument.referenceTransactionId,
            transactionType: paymentTransactionDocument.referenceTransactionType,
            transactionNumber: paymentTransactionDocument.referenceTransactionNumber,
            transactionFinanceType: paymentTransactionDocument.referenceFinanceType,
            transactionExpenseType: paymentTransactionDocument.referenceExpenseType,
            paymentAmount: paymentTransactionDocument.paymentAmount,
            remark: paymentTransactionDocument.remark,
          };
          _paymentGroup.paymentGroupTotal += _paymentTransactionDocument.paymentAmount;
          _paymentGroup.paymentTransactionDocumentList.push(_paymentTransactionDocument);
        }
      }

      _paymentGroup.paymentGroupTotal += _paymentGroup.totalPaidPaymentWithOutChartOfAccount;
      payment.paymentGroupList.push(_paymentGroup);
    }
  }
  return payment;
}
function ConvertToTransactionTimelineGoodsReceipt(goodsReceiptRawList) {
  let goodsReceiptList = [];
  if (goodsReceiptRawList) {
    for (let goodsReceiptRaw of goodsReceiptRawList) {
      goodsReceiptList.push({
        goodsReceiptId: goodsReceiptRaw.goodsReceiptId,
        goodsReceiptNumber: goodsReceiptRaw.goodsReceiptNumber,
      });
    }
  }
  return goodsReceiptList;
}
function ConvertToTransactionTimelineQuotation(quotationRawList) {
  let quotationList = [];
  if (quotationRawList) {
    for (let quotationRaw of quotationRawList) {
      quotationList.push({
        quotationId: quotationRaw.quotationId,
        quotationNumber: quotationRaw.quotationNumber,
      });
    }
  }
  return quotationList;
}
function ConvertToTransactionTimelineInvoice(invoiceRawList) {
  let invoiceList = [];
  if (invoiceRawList) {
    for (let invoiceRaw of invoiceRawList) {
      invoiceList.push({
        invoiceId: invoiceRaw.invoiceId,
        invoiceNumber: invoiceRaw.invoiceNumber,
      });
    }
  }
  return invoiceList;
}
function ConvertToTransactionTimelineInvoiceReceipt(invoiceReceiptRawList) {
  let invoiceReceiptList = [];
  if (invoiceReceiptRawList) {
    for (let invoiceReceiptRaw of invoiceReceiptRawList) {
      invoiceReceiptList.push({
        invoiceReceiptId: invoiceReceiptRaw.invoiceReceiptId,
        invoiceReceiptNumber: invoiceReceiptRaw.invoiceReceiptNumber,
      });
    }
  }
  return invoiceReceiptList;
}
function ConvertToTransactionTimelineJournal(journalRawList) {
  let journalList = [];
  if (journalRawList) {
    for (let journalRaw of journalRawList) {
      journalList.push({
        journalId: journalRaw.journalId,
        journalNumber: journalRaw.journalNumber,
      });
    }
  }
  return journalList;
}
function ConvertToTransactionTimelineReceipt(receiptRawList) {
  let receiptList = [];
  if (receiptRawList) {
    for (let receiptRaw of receiptRawList) {
      receiptList.push({
        receiptId: receiptRaw.receiptId,
        receiptNumber: receiptRaw.receiptNumber,
        receiptIsCreatedTaxInvoice: receiptRaw.receiptIsCreatedTaxInvoice,
        taxInvoiceId: receiptRaw.taxInvoiceId,
        taxInvoiceNumber: receiptRaw.taxInvoiceNumber,
      });
    }
  }
  return receiptList;
}
function ConvertToTransactionTimelineReceiptWithJournal(receiptRawList) {
  let receiptList = [];
  if (receiptRawList) {
    for (let receiptRaw of receiptRawList) {
      receiptList.push({
        receiptId: receiptRaw.receiptId,
        receiptNumber: receiptRaw.receiptNumber,
        receiptIsCreatedTaxInvoice: receiptRaw.receiptIsCreatedTaxInvoice,
        receiptIssuedIsTaxDocument: receiptRaw.receiptIssuedIsTaxDocument,
        taxInvoiceId: receiptRaw.taxInvoiceId,
        taxInvoiceNumber: receiptRaw.taxInvoiceNumber,
        journalList: ConvertToTransactionTimelineJournal(receiptRaw.journalList),
      });
    }
  }
  return receiptList;
}
function ConvertToTransactionTimelineInvoiceBillingNote(billingNoteRawList) {
  let billingNoteList = [];
  if (billingNoteRawList) {
    for (let billingNoteRaw of billingNoteRawList) {
      let billingNote = {
        billingNoteId: billingNoteRaw.billingNoteId,
        billingNoteNumber: billingNoteRaw.billingNoteNumber,
        journalList: ConvertToTransactionTimelineJournal(billingNoteRaw.journalList),
        receiptList: ConvertToTransactionTimelineReceipt(billingNoteRaw.receiptList),
      };
      billingNoteList.push(billingNote);
    }
  }
  return billingNoteList;
}
function ConvertToTransactionTimelineInvoiceCreditNote(creditNoteRawList) {
  let creditNoteList = [];
  if (creditNoteRawList) {
    for (let creditNoteRaw of creditNoteRawList) {
      let creditNote = {
        creditNoteId: creditNoteRaw.creditNoteId,
        creditNoteNumber: creditNoteRaw.creditNoteNumber,
      };
      creditNoteList.push(creditNote);
    }
  }
  return creditNoteList;
}
function ConvertToTransactionTimelineCombinePaymentNote(combinePaymentNoteRawList) {
  let combinePaymentNoteList = [];
  if (combinePaymentNoteRawList) {
    for (let combinePaymentNoteRaw of combinePaymentNoteRawList) {
      let combinePaymentNote = {
        combinePaymentNoteId: combinePaymentNoteRaw.combinePaymentNoteId,
        combinePaymentNoteNumber: combinePaymentNoteRaw.combinePaymentNoteNumber,
        journalList: ConvertToTransactionTimelineJournal(combinePaymentNoteRaw.journalList),
      };
      combinePaymentNoteList.push(combinePaymentNote);
    }
  }
  return combinePaymentNoteList;
}
function ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList) {
  let receivedIssuedTaxInvoiceList = [];
  if (receivedIssuedTaxInvoiceRawList && receivedIssuedTaxInvoiceRawList.length > 0) {
    for (let receivedIssuedTaxInvoiceRaw of receivedIssuedTaxInvoiceRawList) {
      let receivedIssuedTaxInvoice = {
        referencedJournalList: [],
        id: receivedIssuedTaxInvoiceRaw.id,
        receivedTaxInvoiceNumber: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceDate,
        receivedTaxInvoiceJournalDate: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceJournalDate,
        isDefaultDate: false,
        preVatTotal: receivedIssuedTaxInvoiceRaw.preVatTotal,
        vatTotal: receivedIssuedTaxInvoiceRaw.vatTotal,
        netAmount: receivedIssuedTaxInvoiceRaw.netAmount,
        eTaxInvoiceId: receivedIssuedTaxInvoiceRaw.etaxInvoiceId,
        taxInvoiceId: receivedIssuedTaxInvoiceRaw.taxInvoiceId,
        referenceTransactionType: receivedIssuedTaxInvoiceRaw.referenceTransactionType,
        referenceTransactionId: receivedIssuedTaxInvoiceRaw.referenceTransactionId,
        referencePaymentGroupId: receivedIssuedTaxInvoiceRaw.referencePaymentGroupId,
      };
      if (
        receivedIssuedTaxInvoiceRaw.referencedJournalList &&
        receivedIssuedTaxInvoiceRaw.referencedJournalList.length > 0
      ) {
        for (let referenceJournal of receivedIssuedTaxInvoiceRaw.referencedJournalList) {
          receivedIssuedTaxInvoice.referencedJournalList.push({
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      receivedIssuedTaxInvoiceList.push(receivedIssuedTaxInvoice);
    }
    return receivedIssuedTaxInvoiceList;
  }
}

const ConvertToReferenceDepositListDetail = (referenceDepositRawList) => {
  const referenceDepositList = [];
  if (referenceDepositRawList && referenceDepositRawList.length > 0) {
    for (const referenceDepositRaw of referenceDepositRawList) {
      referenceDepositList.push({
        id: referenceDepositRaw.id,
        depositId: referenceDepositRaw.depositId,
        date: null,
        depositNumber: "",
        fromCurrencyWHTTotal: referenceDepositRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceDepositRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceDepositRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceDepositRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceDepositRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceDepositRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceDepositRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceDepositRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceDepositRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceDepositRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceDepositRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceDepositRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceDepositRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceDepositRaw.toCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return referenceDepositList;
};

const ConvertTorReferenceDepositSummaryDetail = (transactionRawData) => {
  return {
    fromCurrencyDepositVatTotal: transactionRawData.fromCurrencyDepositVatTotal,
    fromCurrencyDepositPreVatTotal: transactionRawData.fromCurrencyDepositPreVatTotal,
    fromCurrencyDepositZeroVatTotal: transactionRawData.fromCurrencyDepositZeroVatTotal,
    fromCurrencyDepositVatExemptedTotal: transactionRawData.fromCurrencyDepositVatExemptedTotal,
    toCurrencyDepositVatTotal: transactionRawData.toCurrencyDepositVatTotal,
    toCurrencyDepositPreVatTotal: transactionRawData.toCurrencyDepositPreVatTotal,
    toCurrencyDepositZeroVatTotal: transactionRawData.toCurrencyDepositZeroVatTotal,
    toCurrencyDepositVatExemptedTotal: transactionRawData.toCurrencyDepositVatExemptedTotal,
  };
};

const ConvertToReferenceDepositListCreate = (referenceDepositRawList) => {
  const referenceDepositList = [];
  if (referenceDepositRawList && referenceDepositRawList.length > 0) {
    for (const referenceDepositRaw of referenceDepositRawList) {
      referenceDepositList.push({
        depositId: referenceDepositRaw.depositId,
        fromCurrencyWHTTotal: referenceDepositRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceDepositRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceDepositRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceDepositRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceDepositRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceDepositRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceDepositRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceDepositRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceDepositRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceDepositRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceDepositRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceDepositRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceDepositRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceDepositRaw.toCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return referenceDepositList;
};

export const ConvertToTransactionDetailForDoPaidPayment = (transactionRawData) => {
  const transaction = {
    id: transactionRawData.id,
    number: transactionRawData.number,
    date: transactionRawData.date,
    contactId: transactionRawData.contactId,
    transactionType: transactionRawData.transactionType,
    financeType: transactionRawData.financeType,
    expenseType: transactionRawData.transactionItemType,
    isCreatedTaxInvoice: transactionRawData.isCreatedTaxInvoice, //
    transactionSummary: {
      preVatTotal: transactionRawData.fromCurrency.preVatTotal,
      zeroVatTotal: transactionRawData.fromCurrency.zeroVatTotal,
      vatExemptedTotal: transactionRawData.fromCurrency.vatExemptedTotal,
      vatTotal: transactionRawData.fromCurrency.vatTotal,
      subTotal:
        transactionRawData.fromCurrency.vatExemptedTotal +
        transactionRawData.fromCurrency.zeroVatTotal +
        transactionRawData.fromCurrency.preVatTotal,
      netAmount: transactionRawData.fromCurrency.netTotal,
      subTotalForCalculateWht: transactionRawData.fromCurrency.subTotalForcalculateWHT,
      whtTotal: transactionRawData.fromCurrency.whtTotal,
      remainPaymentNetAmount: transactionRawData.remainPaymentDetail.remainPaymentAmount,
      remainWhtPaymentNetAmount: transactionRawData.remainPaymentDetail.remainWhtPaymentAmount,
      isAllNoneOrNotSpecifyWht: transactionRawData.isNoneOrNotSpecifyWht,
      isServiceOnly: transactionRawData.isServiceOnly,
      sameProductVatType: transactionRawData.sameProductVatType,
    },
  };
  if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
    transaction.transactionItemList = [];
    for (let transactionItem of transactionRawData.transactionItemList) {
      if (!transactionItem.isDescriptionOnly) {
        transaction.transactionItemList.push({
          accountId: transactionItem.accountId,
          quantity: transactionItem.quantity,
          toCurrencyPrice: transactionItem.toCurrencyPrice,
          discountType: transactionItem.discountType,
          toCurrencyDiscount: transactionItem.toCurrencyDiscount,
          vatType: transactionItem.vatType,
          toCurrencyWHTTotal: transactionItem.toCurrencyWHTTotal,
          whtAmountType: transactionItem.whtAmountType,
        });
        transaction.transactionItemList.push(transactionItem);
      }
    }
  }
  return transaction;
};
export const GetCreateTransactionBase = (transaction) => {
  const transactionItemModel = GetTransactionItemList(transaction);
  SetTransactionItemList(transaction, transactionItemModel);
  const summary = GetTransactionSummary(transaction, transactionItemModel);
  const transactionBase = {
    number: transaction.number.value,
    date: transaction.date.value,
    remark: transaction.remark.text,
    contactId: transaction.contact.id,
    referenceName: transaction.reference.referenceName,
    taxStatus: transaction.taxStatus.value,
    currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
    currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
    fromCurrencyUId: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
    toCurrencyUId: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
    fromCurrency: {
      discount: transaction.transactionSummary.discount.ToNumber(),
      whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
      netTotal: transaction.transactionSummary.netAmount.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      subTotalForcalculateWHT: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
    },
    toCurrency: {
      discount: transaction.transactionCurrencySummary.discount.ToNumber(),
      whtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
      netTotal: transaction.transactionCurrencySummary.netAmount.ToNumber(),
      vatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
      preVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
      zeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
      subTotalForcalculateWHT: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
    },
    discountType: transaction.transactionDiscount.discountType,
    tagList: transaction.tagList,
    allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    transactionItemList: [],
  };

  return transactionBase;
};
export const GetCreateTransactionItemBase = (transaction, transactionItem) => {
  const transactionItemBase = {
    description: transactionItem.description.text,
    vatType: transactionItem.vatTypeId.value,
    discountType: transactionItem.discount.discountTypeId,
    quantity: transactionItem.amount.value.ToNumber(),
    isDescriptionOnly: transactionItem.isDescriptionOnly,
    whtAmountType: transactionItem.itemWht.whtAmountType,
    fromCurrencyPrice: transactionItem.fromCurrencyPrice.ToNumber(),
    fromCurrencyDiscount: transactionItem.fromCurrencyDiscount.ToNumber(),
    fromCurrencyWHTTotal: transactionItem.fromCurrencyWHTTotal.ToNumber(),
    fromCurrencyNetTotal: transactionItem.fromCurrencyNetTotal.ToNumber(),
    fromCurrencyVatTotal: transactionItem.fromCurrencyVatTotal.ToNumber(),
    fromCurrencyPreVatTotal: transactionItem.fromCurrencyPreVatTotal.ToNumber(),
    fromCurrencyZeroVatTotal: transactionItem.fromCurrencyZeroVatTotal.ToNumber(),
    fromCurrencyVatExemptedTotal: transactionItem.fromCurrencyVatExemptedTotal.ToNumber(),
    fromCurrencySubTotalForcalculateWHT: transactionItem.fromCurrencySubTotalForcalculateWHT.ToNumber(),
    toCurrencyPrice: transactionItem.toCurrencyPrice.ToNumber(),
    toCurrencyDiscount: transactionItem.toCurrencyDiscount.ToNumber(),
    toCurrencyWHTTotal: transactionItem.toCurrencyWHTTotal.ToNumber(),
    toCurrencyNetTotal: transactionItem.toCurrencyNetTotal.ToNumber(),
    toCurrencyVatTotal: transactionItem.toCurrencyVatTotal.ToNumber(),
    toCurrencyPreVatTotal: transactionItem.toCurrencyPreVatTotal.ToNumber(),
    toCurrencyZeroVatTotal: transactionItem.toCurrencyZeroVatTotal.ToNumber(),
    toCurrencyVatExemptedTotal: transactionItem.toCurrencyVatExemptedTotal.ToNumber(),
    toCurrencySubTotalForcalculateWHT: transactionItem.toCurrencySubTotalForcalculateWHT.ToNumber(),
    allocationTransactionList: transactionItem.isUseTransactionAllocation
      ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
      : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
  };

  return transactionItemBase;
};

export const GetReceivedTaxInvoiceList = (transaction) => {
  const receivedTaxInvoiceList = [];
  if (
    transaction.receivedTaxInvoice &&
    transaction.receivedTaxInvoice.value &&
    transaction.receivedTaxInvoice.value.length > 0
  ) {
    let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
    receivedTaxInvoiceList.push({
      receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
      receivedTaxInvoiceJournalDate: receivedTaxInvoice.receivedTaxInvoiceJournalDate,
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      netAmount:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        transaction.transactionSummary.vat.vatTotal.ToNumber(),
    });
  }
  return receivedTaxInvoiceList;
};
export const GetCreatePurchaseRequisitionInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditPurchaseRequisitionInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreatePurchaseRequisitionInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreateQuotationInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditQuotationInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateQuotationInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreatePurchaseOrderInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditPurchaseOrderInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreatePurchaseOrderInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreatePurchaseOrderAssetInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.assetTemplateId = transactionItem.fixedAssetTemplate.id;
        transactionItemCreate.isAcquisitionCost = transactionItem.fixedAssetTemplate.isService;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditPurchaseOrderAssetInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreatePurchaseOrderAssetInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreateDepositInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditDepositInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateDepositInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};
export const GetCreateReceivedDepositInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.receivedTaxInvoiceList = GetReceivedTaxInvoiceList(transaction);
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditReceivedDepositInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateReceivedDepositInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};
export const GetCreateGoodsReceiptInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditGoodsReceiptInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateGoodsReceiptInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};
export const GetCreateInvoiceReceiptInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.receivedTaxInvoiceList = GetReceivedTaxInvoiceList(transaction);
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditInvoiceReceiptInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateInvoiceReceiptInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};
export const GetCreateInvoiceInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};
export const GetEditInvoiceInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateInvoiceInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreateInvoiceSaleAssetInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.assetId = transactionItem.fixedAsset.id;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditInvoiceSaleAssetInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateInvoiceSaleAssetInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreatePurchaseInventoryInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.receivedTaxInvoiceList = GetReceivedTaxInvoiceList(transaction);
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditPurchaseInventoryInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreatePurchaseInventoryInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreatePurchaseAssetInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.receivedTaxInvoiceList = GetReceivedTaxInvoiceList(transaction);
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.assetTemplateId = transactionItem.fixedAssetTemplate.id;
        transactionItemCreate.isAcquisitionCost = transactionItem.fixedAssetTemplate.isService;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditPurchaseAssetInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreatePurchaseAssetInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreateReceiptInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.referencePaymentGroupId = transaction.reference.paymentGroupId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.productTemplateId = transactionItem.productTemplate.id;
        transactionItemCreate.accountId = transactionItem.account.id;
        transactionItemCreate.referenceQuotationItemId = transactionItem.referenceQuotationItemId;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditReceiptInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateReceiptInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const GetCreateReceiptSaleAssetInput = (status, transaction) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceTransactionId = transaction.reference.referenceId;
  transactionCreate.referenceTransactionType = transaction.reference.referenceTypeId;
  transactionCreate.referencePaymentGroupId = transaction.reference.paymentGroupId;
  transactionCreate.isCreatedTaxInvoice = transaction.issueTaxInvoice.value;
  transactionCreate.isTaxDocument = transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value;
  transactionCreate.paymentGroup = ConvertPaymentGroupForCreateModel(transaction.payment, transaction.financeType);
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal =
    transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal =
    transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.quotationReferenceTransactionType = transaction.quotationReferenceTransactionType;

  if (transaction.transactionItemList) {
    for (let transactionItem of transaction.transactionItemList) {
      if (transactionItem.checked && transactionItem.checked.value) {
        const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
        transactionItemCreate.assetId = transactionItem.fixedAsset.id;
        transactionCreate.transactionItemList.push(transactionItemCreate);
      }
    }
  }

  return transactionCreate;
};

export const GetEditReceiptSaleAssetInput = (transactionId, status, transaction) => {
  const transactionEdit = GetCreateReceiptSaleAssetInput(status, transaction);
  transactionEdit.id = transactionId;
  return transactionEdit;
};

export const ConvertToDepositRemainingList = (remainingRawDataList) => {
  const remainingList = [];
  if (remainingRawDataList && remainingRawDataList.length > 0) {
    for (const remainingRawData of remainingRawDataList) {
      remainingList.push({
        id: remainingRawData.id,
        contactId: remainingRawData.contactId,
        depositDatabaseStatus: remainingRawData.depositDatabaseStatus,
        isDeleted: remainingRawData.isDeleted,
        number: remainingRawData.number,
        date: remainingRawData.date,
        referenceTransactionTotal: remainingRawData.referenceTransactionTotal,
        remainingFromCurrencyWHTTotal: remainingRawData.remainingFromCurrencyWHTTotal,
        remainingFromCurrencyNetTotal: remainingRawData.remainingFromCurrencyNetTotal,
        remainingFromCurrencyVatTotal: remainingRawData.remainingFromCurrencyVatTotal,
        remainingFromCurrencyPreVatTotal: remainingRawData.remainingFromCurrencyPreVatTotal,
        remainingFromCurrencyZeroVatTotal: remainingRawData.remainingFromCurrencyZeroVatTotal,
        remainingFromCurrencyVatExemptedTotal: remainingRawData.remainingFromCurrencyVatExemptedTotal,
        remainingFromCurrencySubTotalForcalculateWHT: remainingRawData.remainingFromCurrencySubTotalForcalculateWHT,
        remainingToCurrencyWHTTotal: remainingRawData.remainingToCurrencyWHTTotal,
        remainingToCurrencyNetTotal: remainingRawData.remainingToCurrencyNetTotal,
        remainingToCurrencyVatTotal: remainingRawData.remainingToCurrencyVatTotal,
        remainingToCurrencyPreVatTotal: remainingRawData.remainingToCurrencyPreVatTotal,
        remainingToCurrencyZeroVatTotal: remainingRawData.remainingToCurrencyZeroVatTotal,
        remainingToCurrencyVatExemptedTotal: remainingRawData.remainingToCurrencyVatExemptedTotal,
        remainingToCurrencySubTotalForcalculateWHT: remainingRawData.remainingToCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return remainingList;
};

export const ConvertToInvoiceReceiptRemainingList = (remainingRawDataList) => {
  const remainingList = [];
  if (remainingRawDataList && remainingRawDataList.length > 0) {
    for (const remainingRawData of remainingRawDataList) {
      remainingList.push({
        invoiceReceiptDatabaseStatus: remainingRawData.invoiceReceiptDatabaseStatus,
        isDeleted: remainingRawData.isDeleted,
        number: remainingRawData.number,
        id: remainingRawData.id,
        contactId: remainingRawData.contactId,
        isVat: remainingRawData.isVat,
        taxStatus: remainingRawData.taxStatus,
        discountType: remainingRawData.discountType,
        lockStatus: remainingRawData.lockStatus,
        fromCurrencyDiscount: remainingRawData.fromCurrencyDiscount,
        toCurrencyDiscount: remainingRawData.toCurrencyDiscount,
        fromCurrencyWHTTotal: remainingRawData.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: remainingRawData.fromCurrencyNetTotal,
        fromCurrencyVatTotal: remainingRawData.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: remainingRawData.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: remainingRawData.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: remainingRawData.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: remainingRawData.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: remainingRawData.toCurrencyWHTTotal,
        toCurrencyNetTotal: remainingRawData.toCurrencyNetTotal,
        toCurrencyVatTotal: remainingRawData.toCurrencyVatTotal,
        toCurrencyPreVatTotal: remainingRawData.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: remainingRawData.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: remainingRawData.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: remainingRawData.toCurrencySubTotalForcalculateWHT,
        remainingFromCurrencyWHTTotal: remainingRawData.remainingFromCurrencyWHTTotal,
        remainingFromCurrencyNetTotal: remainingRawData.remainingFromCurrencyNetTotal,
        remainingFromCurrencyVatTotal: remainingRawData.remainingFromCurrencyVatTotal,
        remainingFromCurrencyPreVatTotal: remainingRawData.remainingFromCurrencyPreVatTotal,
        remainingFromCurrencyZeroVatTotal: remainingRawData.remainingFromCurrencyZeroVatTotal,
        remainingFromCurrencyVatExemptedTotal: remainingRawData.remainingFromCurrencyVatExemptedTotal,
        remainingFromCurrencySubTotalForcalculateWHT: remainingRawData.remainingFromCurrencySubTotalForcalculateWHT,
        remainingToCurrencyWHTTotal: remainingRawData.remainingToCurrencyWHTTotal,
        remainingToCurrencyNetTotal: remainingRawData.remainingToCurrencyNetTotal,
        remainingToCurrencyVatTotal: remainingRawData.remainingToCurrencyVatTotal,
        remainingToCurrencyPreVatTotal: remainingRawData.remainingToCurrencyPreVatTotal,
        remainingToCurrencyZeroVatTotal: remainingRawData.remainingToCurrencyZeroVatTotal,
        remainingToCurrencyVatExemptedTotal: remainingRawData.remainingToCurrencyVatExemptedTotal,
        remainingToCurrencySubTotalForcalculateWHT: remainingRawData.remainingToCurrencySubTotalForcalculateWHT,
        fromCurrencyDepositPreVatTotal: remainingRawData.fromCurrencyDepositPreVatTotal,
        fromCurrencyDepositVatExemptedTotal: remainingRawData.fromCurrencyDepositVatExemptedTotal,
        fromCurrencyDepositVatTotal: remainingRawData.fromCurrencyDepositVatTotal,
        fromCurrencyDepositZeroVatTotal: remainingRawData.fromCurrencyDepositZeroVatTotal,
        toCurrencyDepositPreVatTotal: remainingRawData.toCurrencyDepositPreVatTotal,
        toCurrencyDepositVatExemptedTotal: remainingRawData.toCurrencyDepositVatExemptedTotal,
        toCurrencyDepositVatTotal: remainingRawData.toCurrencyDepositVatTotal,
        toCurrencyDepositZeroVatTotal: remainingRawData.toCurrencyDepositZeroVatTotal,
        transactionItemList: ConvertToInvoiceReceiptItemRemainingList(remainingRawData.transactionItemList),
      });
    }
  }
  return remainingList;
};

export const ConvertToInvoiceReceiptItemRemainingList = (transactionItemRawDataList) => {
  const transactionItemList = [];
  if (transactionItemRawDataList && transactionItemRawDataList.length > 0) {
    for (const transactionItemRawData of transactionItemRawDataList) {
      transactionItemList.push({
        id: transactionItemRawData.id,
        vatType: transactionItemRawData.vatType,
        whtAmountType: transactionItemRawData.whtAmountType,
        discountType: transactionItemRawData.discountType,
        productTemplateId: transactionItemRawData.productTemplateId,
        accountId: transactionItemRawData.accountId,
        quantity: transactionItemRawData.quantity,
        fromCurrencyPrice: transactionItemRawData.fromCurrencyPrice,
        fromCurrencyDiscount: transactionItemRawData.fromCurrencyDiscount,
        fromCurrencyWHTTotal: transactionItemRawData.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: transactionItemRawData.fromCurrencyNetTotal,
        fromCurrencyVatTotal: transactionItemRawData.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: transactionItemRawData.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: transactionItemRawData.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: transactionItemRawData.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: transactionItemRawData.fromCurrencySubTotalForcalculateWHT,
        toCurrencyPrice: transactionItemRawData.toCurrencyPrice,
        toCurrencyDiscount: transactionItemRawData.toCurrencyDiscount,
        toCurrencyWHTTotal: transactionItemRawData.toCurrencyWHTTotal,
        toCurrencyNetTotal: transactionItemRawData.toCurrencyNetTotal,
        toCurrencyVatTotal: transactionItemRawData.toCurrencyVatTotal,
        toCurrencyPreVatTotal: transactionItemRawData.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: transactionItemRawData.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: transactionItemRawData.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: transactionItemRawData.toCurrencySubTotalForcalculateWHT,
        fromCurrencyPriceWithTransactionDiscount: transactionItemRawData.fromCurrencyPriceWithTransactionDiscount,
        remainingQuantity: transactionItemRawData.remainingQuantity,
        remainingFromCurrencyWHTTotal: transactionItemRawData.remainingFromCurrencyWHTTotal,
        remainingFromCurrencyNetTotal: transactionItemRawData.remainingFromCurrencyNetTotal,
        remainingFromCurrencyVatTotal: transactionItemRawData.remainingFromCurrencyVatTotal,
        remainingFromCurrencyPreVatTotal: transactionItemRawData.remainingFromCurrencyPreVatTotal,
        remainingFromCurrencyZeroVatTotal: transactionItemRawData.remainingFromCurrencyZeroVatTotal,
        remainingFromCurrencyVatExemptedTotal: transactionItemRawData.remainingFromCurrencyVatExemptedTotal,
        remainingFromCurrencySubTotalForcalculateWHT:
          transactionItemRawData.remainingFromCurrencySubTotalForcalculateWHT,
        remainingToCurrencyWHTTotal: transactionItemRawData.remainingToCurrencyWHTTotal,
        remainingToCurrencyNetTotal: transactionItemRawData.remainingToCurrencyNetTotal,
        remainingToCurrencyVatTotal: transactionItemRawData.remainingToCurrencyVatTotal,
        remainingToCurrencyPreVatTotal: transactionItemRawData.remainingToCurrencyPreVatTotal,
        remainingToCurrencyZeroVatTotal: transactionItemRawData.remainingToCurrencyZeroVatTotal,
        remainingToCurrencyVatExemptedTotal: transactionItemRawData.remainingToCurrencyVatExemptedTotal,
        remainingToCurrencySubTotalForcalculateWHT: transactionItemRawData.remainingToCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return transactionItemList;
};

export const ConvertToGoodsReceiptRemainingList = (remainingRawDataList) => {
  const remainingList = [];
  if (remainingRawDataList && remainingRawDataList.length > 0) {
    for (const remainingRawData of remainingRawDataList) {
      remainingList.push({
        goodsReceiptDatabaseStatus: remainingRawData.goodsReceiptDatabaseStatus,
        isDeleted: remainingRawData.isDeleted,
        number: remainingRawData.number,
        id: remainingRawData.id,
        contactId: remainingRawData.contactId,
        isVat: remainingRawData.isVat,
        taxStatus: remainingRawData.taxStatus,
        discountType: remainingRawData.discountType,
        lockStatus: remainingRawData.lockStatus,
        fromCurrencyDiscount: remainingRawData.fromCurrencyDiscount,
        toCurrencyDiscount: remainingRawData.toCurrencyDiscount,
        fromCurrencyWHTTotal: remainingRawData.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: remainingRawData.fromCurrencyNetTotal,
        fromCurrencyVatTotal: remainingRawData.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: remainingRawData.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: remainingRawData.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: remainingRawData.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: remainingRawData.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: remainingRawData.toCurrencyWHTTotal,
        toCurrencyNetTotal: remainingRawData.toCurrencyNetTotal,
        toCurrencyVatTotal: remainingRawData.toCurrencyVatTotal,
        toCurrencyPreVatTotal: remainingRawData.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: remainingRawData.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: remainingRawData.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: remainingRawData.toCurrencySubTotalForcalculateWHT,
        remainingFromCurrencyWHTTotal: remainingRawData.remainingFromCurrencyWHTTotal,
        remainingFromCurrencyNetTotal: remainingRawData.remainingFromCurrencyNetTotal,
        remainingFromCurrencyVatTotal: remainingRawData.remainingFromCurrencyVatTotal,
        remainingFromCurrencyPreVatTotal: remainingRawData.remainingFromCurrencyPreVatTotal,
        remainingFromCurrencyZeroVatTotal: remainingRawData.remainingFromCurrencyZeroVatTotal,
        remainingFromCurrencyVatExemptedTotal: remainingRawData.remainingFromCurrencyVatExemptedTotal,
        remainingFromCurrencySubTotalForcalculateWHT: remainingRawData.remainingFromCurrencySubTotalForcalculateWHT,
        remainingToCurrencyWHTTotal: remainingRawData.remainingToCurrencyWHTTotal,
        remainingToCurrencyNetTotal: remainingRawData.remainingToCurrencyNetTotal,
        remainingToCurrencyVatTotal: remainingRawData.remainingToCurrencyVatTotal,
        remainingToCurrencyPreVatTotal: remainingRawData.remainingToCurrencyPreVatTotal,
        remainingToCurrencyZeroVatTotal: remainingRawData.remainingToCurrencyZeroVatTotal,
        remainingToCurrencyVatExemptedTotal: remainingRawData.remainingToCurrencyVatExemptedTotal,
        remainingToCurrencySubTotalForcalculateWHT: remainingRawData.remainingToCurrencySubTotalForcalculateWHT,
        transactionItemList: ConvertToGoodsReceiptItemRemainingList(remainingRawData.transactionItemList),
      });
    }
  }
  return remainingList;
};

export const ConvertToGoodsReceiptItemRemainingList = (transactionItemRawDataList) => {
  const transactionItemList = [];
  if (transactionItemRawDataList && transactionItemRawDataList.length > 0) {
    for (const transactionItemRawData of transactionItemRawDataList) {
      transactionItemList.push({
        id: transactionItemRawData.id,
        vatType: transactionItemRawData.vatType,
        whtAmountType: transactionItemRawData.whtAmountType,
        discountType: transactionItemRawData.discountType,
        productTemplateId: transactionItemRawData.productTemplateId,
        accountId: transactionItemRawData.accountId,
        quantity: transactionItemRawData.quantity,
        fromCurrencyPrice: transactionItemRawData.fromCurrencyPrice,
        fromCurrencyDiscount: transactionItemRawData.fromCurrencyDiscount,
        fromCurrencyWHTTotal: transactionItemRawData.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: transactionItemRawData.fromCurrencyNetTotal,
        fromCurrencyVatTotal: transactionItemRawData.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: transactionItemRawData.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: transactionItemRawData.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: transactionItemRawData.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: transactionItemRawData.fromCurrencySubTotalForcalculateWHT,
        toCurrencyPrice: transactionItemRawData.toCurrencyPrice,
        toCurrencyDiscount: transactionItemRawData.toCurrencyDiscount,
        toCurrencyWHTTotal: transactionItemRawData.toCurrencyWHTTotal,
        toCurrencyNetTotal: transactionItemRawData.toCurrencyNetTotal,
        toCurrencyVatTotal: transactionItemRawData.toCurrencyVatTotal,
        toCurrencyPreVatTotal: transactionItemRawData.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: transactionItemRawData.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: transactionItemRawData.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: transactionItemRawData.toCurrencySubTotalForcalculateWHT,
        fromCurrencyPriceWithTransactionDiscount: transactionItemRawData.fromCurrencyPriceWithTransactionDiscount,
        remainingQuantity: transactionItemRawData.remainingQuantity,
        remainingFromCurrencyWHTTotal: transactionItemRawData.remainingFromCurrencyWHTTotal,
        remainingFromCurrencyNetTotal: transactionItemRawData.remainingFromCurrencyNetTotal,
        remainingFromCurrencyVatTotal: transactionItemRawData.remainingFromCurrencyVatTotal,
        remainingFromCurrencyPreVatTotal: transactionItemRawData.remainingFromCurrencyPreVatTotal,
        remainingFromCurrencyZeroVatTotal: transactionItemRawData.remainingFromCurrencyZeroVatTotal,
        remainingFromCurrencyVatExemptedTotal: transactionItemRawData.remainingFromCurrencyVatExemptedTotal,
        remainingFromCurrencySubTotalForcalculateWHT:
          transactionItemRawData.remainingFromCurrencySubTotalForcalculateWHT,
        remainingToCurrencyWHTTotal: transactionItemRawData.remainingToCurrencyWHTTotal,
        remainingToCurrencyNetTotal: transactionItemRawData.remainingToCurrencyNetTotal,
        remainingToCurrencyVatTotal: transactionItemRawData.remainingToCurrencyVatTotal,
        remainingToCurrencyPreVatTotal: transactionItemRawData.remainingToCurrencyPreVatTotal,
        remainingToCurrencyZeroVatTotal: transactionItemRawData.remainingToCurrencyZeroVatTotal,
        remainingToCurrencyVatExemptedTotal: transactionItemRawData.remainingToCurrencyVatExemptedTotal,
        remainingToCurrencySubTotalForcalculateWHT: transactionItemRawData.remainingToCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return transactionItemList;
};

export const ConvertToSummaryAndCurrency = (transaction) => {
  const transactionItemModel = GetTransactionItemList(transaction);
  const summary = GetTransactionSummary(transaction, transactionItemModel);
  let SummaryAndCurrency = {
    transactionSummary: {
      subTotal:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        summary.transactionSummary.vatExemptedTotal.ToNumber() +
        summary.transactionSummary.zeroVatTotal.ToNumber(),
      netAmount: transaction.transactionSummary.netAmount.ToNumber(),
      whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      subTotalForCalculateWht: summary.transactionSummary.subTotalForCalculateWht.ToNumber(),
      isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
      isServiceOnly: transaction.transactionSummary.isServiceOnly,
      sameProductVatType: transaction.transactionSummary.sameProductVatType,
    },
    transactionCurrency: {
      currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
      currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
      currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
      currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
      currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
      currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
      currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
      currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
      currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
      fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
      toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
    },
  };
  return SummaryAndCurrency;
};

export const GetInputReferenceTransactionBase = (transactionReferenceTransactionModel) => {
  const referenceTransactionBase = {
    fromCurrencyWHTTotal: transactionReferenceTransactionModel.fromCurrencyWHTTotal,
    fromCurrencyNetTotal: transactionReferenceTransactionModel.fromCurrencyNetTotal,
    fromCurrencyVatTotal: transactionReferenceTransactionModel.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: transactionReferenceTransactionModel.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: transactionReferenceTransactionModel.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: transactionReferenceTransactionModel.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: transactionReferenceTransactionModel.fromCurrencySubTotalForcalculateWHT,
    toCurrencyWHTTotal: transactionReferenceTransactionModel.toCurrencyWHTTotal,
    toCurrencyNetTotal: transactionReferenceTransactionModel.toCurrencyNetTotal,
    toCurrencyVatTotal: transactionReferenceTransactionModel.toCurrencyVatTotal,
    toCurrencyPreVatTotal: transactionReferenceTransactionModel.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: transactionReferenceTransactionModel.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: transactionReferenceTransactionModel.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: transactionReferenceTransactionModel.toCurrencySubTotalForcalculateWHT,
    transactionItemList: [],
  };
  return referenceTransactionBase;
};

export const GetInputReferenceTransactionItemBase = (transactionItemRaw) => {
  const transactionItem = {
    quantity: transactionItemRaw.quantity,
    fromCurrencyWHTTotal: transactionItemRaw.fromCurrencyWHTTotal,
    fromCurrencyNetTotal: transactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotal: transactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: transactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: transactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: transactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: transactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyWHTTotal: transactionItemRaw.toCurrencyWHTTotal,
    toCurrencyNetTotal: transactionItemRaw.toCurrencyNetTotal,
    toCurrencyVatTotal: transactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotal: transactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: transactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: transactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: transactionItemRaw.toCurrencySubTotalForcalculateWHT,
  };

  return transactionItem;
};

export const GetInputReferenceGoodsReceiptList = (transactionReferenceTransactionModel) => {
  const referenceGoodsReceiptList = [];
  if (transactionReferenceTransactionModel) {
    const referenceGoodsReceipt = GetInputReferenceTransactionBase(transactionReferenceTransactionModel);
    referenceGoodsReceipt.goodsReceiptId = transactionReferenceTransactionModel.referenceTransactionId;
    referenceGoodsReceipt.transactionItemList = GetInputReferenceGoodsReceiptItemList(
      transactionReferenceTransactionModel
    );
    referenceGoodsReceiptList.push(referenceGoodsReceipt);
  }

  return referenceGoodsReceiptList;
};

export const GetInputReferenceGoodsReceiptItemList = (transactionReferenceTransactionModel) => {
  const transactionItemList = [];
  if (
    transactionReferenceTransactionModel.transactionItemList &&
    transactionReferenceTransactionModel.transactionItemList.length > 0
  ) {
    for (const transactionItemRaw of transactionReferenceTransactionModel.transactionItemList) {
      const transactionItem = GetInputReferenceTransactionItemBase(transactionItemRaw);
      transactionItem.goodsReceiptItemId = transactionItemRaw.referenceTransactionItemId;
      transactionItem.invoiceReceiptItemId = transactionItemRaw.transactionItemId;
      transactionItemList.push(transactionItem);
    }
  }
  return transactionItemList;
};

export const GetInputReferenceInvoiceReceiptList = (transactionReferenceTransactionModel) => {
  const referenceGoodsReceiptList = [];
  if (transactionReferenceTransactionModel) {
    const referenceGoodsReceipt = GetInputReferenceTransactionBase(transactionReferenceTransactionModel);
    referenceGoodsReceipt.invoiceReceiptId = transactionReferenceTransactionModel.referenceTransactionId;
    referenceGoodsReceipt.transactionItemList = GetInputReferenceInvoiceReceiptItemList(
      transactionReferenceTransactionModel
    );
    referenceGoodsReceiptList.push(referenceGoodsReceipt);
  }

  return referenceGoodsReceiptList;
};

export const GetInputReferenceInvoiceReceiptItemList = (transactionReferenceTransactionModel) => {
  const transactionItemList = [];
  if (
    transactionReferenceTransactionModel.transactionItemList &&
    transactionReferenceTransactionModel.transactionItemList.length > 0
  ) {
    for (const transactionItemRaw of transactionReferenceTransactionModel.transactionItemList) {
      const transactionItem = GetInputReferenceTransactionItemBase(transactionItemRaw);
      transactionItem.invoiceReceiptItemId = transactionItemRaw.referenceTransactionItemId;
      transactionItem.goodsReceiptItemId = transactionItemRaw.transactionItemId;
      transactionItemList.push(transactionItem);
    }
  }
  return transactionItemList;
};

export const ConvertReferenceQuotationItemForDetail = (transactionDetail, partialPurchaseOrder) => {
  const partialPurchaseOrderFprMap = new Map();
  if (
    partialPurchaseOrder &&
    partialPurchaseOrder.transactionItemList &&
    partialPurchaseOrder.transactionItemList.length > 0
  ) {
    for (const partialPurchaseOrderItem of partialPurchaseOrder.transactionItemList) {
      partialPurchaseOrderFprMap.set(partialPurchaseOrderItem.id, partialPurchaseOrderItem);
    }
  }

  if (transactionDetail && transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    for (const transactionItem of transactionDetail.transactionItems) {
      const partialPurchaseOrderItem = partialPurchaseOrderFprMap.get(transactionItem.referenceQuotationItemId);
      if (transactionItem.referenceQuotationItemId > 0 && partialPurchaseOrderItem) {
        transactionItem.referenceQuotationItem = {
          discount: partialPurchaseOrderItem.discount,
          discountType: partialPurchaseOrderItem.discountType,
          price: partialPurchaseOrderItem.price,
          referenceQuotationItemId: transactionItem.referenceQuotationItemId,
          remainingQuantity: partialPurchaseOrderItem.remainingQuantity,
          whtAmount: partialPurchaseOrderItem.whtAmount,
          whtAmountType: partialPurchaseOrderItem.whtAmountType,
        };
      } else {
        transactionItem.referenceQuotationItem = {
          discount: 0,
          discountType: 0,
          price: 0,
          referenceQuotationItemId: 0,
          remainingQuantity: 0,
          whtAmount: 0,
          whtAmountType: 0,
        };
      }
    }
  }
};

export const ConvertToTransactionForCreatePayment = (transactionRaw, transactionType) => {
  let fromCurrencyNetAmount = 0;

  if (
    transactionType == Enums.TransactionType.Invoice ||
    transactionType == Enums.TransactionType.DebitNote ||
    transactionType == Enums.TransactionType.BillingNote
  ) {
    fromCurrencyNetAmount = transactionRaw.netAmount;
  } else if (transactionType == Enums.TransactionType.Deposit) {
    fromCurrencyNetAmount = transactionRaw.fromCurrencyNetTotal;
  }

  return {
    id: transactionRaw.id,
    transactionId: transactionRaw.id,
    transactionType: transactionType,
    transactionItemType: transactionRaw.transactionItemType,
    date: transactionRaw.date,
    dueDate: transactionRaw.dueDate,
    number: transactionRaw.number,
    fromCurrencyNetAmount: fromCurrencyNetAmount,
    contactId: transactionRaw.contactId,
    toCurrencyUId: transactionRaw.toCurrencyUId ? transactionRaw.toCurrencyUId : 0,
    status: transactionRaw.status,
    remainingPayment: 0,
    remainingWhtPayment: null,
    check: false,
    transactionWithPaymentGroup: null,
  };
};

export const ConvertToTransactionForCreatePaymentList = (transactionListRaw, transactionType) => {
  const transactionList = [];
  if (transactionListRaw && transactionListRaw.length > 0) {
    for (const transactionRaw of transactionListRaw) {
      transactionList.push(ConvertToTransactionForCreatePayment(transactionRaw, transactionType));
    }
  }
  return transactionList;
};

export const ConvertToTransactionViewDetail = (transactionViewDetailList, transactionId) => {
  let transactionViewDetail = null;

  if (transactionViewDetailList && transactionViewDetailList.length > 0) {
    transactionViewDetail = transactionViewDetailList.find(
      (transactionViewDetail) => transactionViewDetail.id === transactionId
    );
  }

  return transactionViewDetail ? transactionViewDetail : null;
};

export const GetValidateOverRemainingQuotationInput = (_input) => {
  const quotationId =
    _input.transaction.reference.referenceTypeId === Enums.TransactionType.Quotation
      ? _input.transaction.reference.referenceId
      : 0;

  return {
    isValidateOverRemainingQO: _input.isValidateOverRemainingQO,
    quotationId: quotationId,
    transactionId: _input.transaction.id,
    transactionType: _input.transaction.transactionType,
    toCurrencyNetTotal: _input.transaction.transactionCurrencySummary.netAmount,
    financeType: _input.transaction.financeType,
  };
};

export const ConvertToQuotationForCreateTransaction = (_quotationForCreateTransaction) => {
  let quotationForCreateTransaction = null;

  if (_quotationForCreateTransaction && _quotationForCreateTransaction.id > 0) {
    quotationForCreateTransaction = ConvertToTransactionDetail(_quotationForCreateTransaction);
    quotationForCreateTransaction.transactionItemType = _quotationForCreateTransaction.transactionItemType;
    quotationForCreateTransaction.quotationReferenceTransactionType = _quotationForCreateTransaction.type;
    quotationForCreateTransaction.remainingToCurrencyNetTotal =
      _quotationForCreateTransaction.remainingToCurrencyNetTotal;
  }

  return quotationForCreateTransaction;
};

export default {
  GetCreateQuotationInputOld(status, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      dueDate: transaction.dueDate.hidden ? null : transaction.dueDate.value,
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value,
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
        creditLimit: transaction.contact.creditLimit,
        creditLimitSettingType: transaction.contact.creditLimitSettingType,
      },
      transactionItemType: transaction.transactionItemType,
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      referenceName: transaction.reference.referenceName,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          description: transactionItem.description.text,
          price: transactionItem.price.value.ToNumber(),
          amount: transactionItem.amount.value.ToNumber(),
          discount: transactionItem.discount.value.ToNumber(),
          vatType: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id,
          assetTemplateId: transactionItem.fixedAssetTemplate.id,
          isAcquisitionCost: transactionItem.fixedAssetTemplate.isService,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
          allocationTransactionList: transactionItem.isUseTransactionAllocation
            ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
            : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
        };
        transactionCreate.transactionItemList.push(_transactionItem);
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transactionCreate.transactionItemType,
    };
  },
  GetCreateInvoiceInputOld(status, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      dueDate: transaction.dueDate.value,
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value,
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
        creditLimit: transaction.contact.creditLimit,
        creditLimitSettingType: transaction.contact.creditLimitSettingType,
      },
      financeTypeId: transaction.financeType,
      expenseTypeId: transaction.expenseType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      purchaseTaxInvoiceRefNumber: null,
      purchaseTaxInvoiceRefDate: null,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      receivedTaxInvoiceList: [],
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        receivedTaxInvoiceJournalDate: receivedTaxInvoice.receivedTaxInvoiceJournalDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.id > 0 ? transactionItem.productTemplate.code : "",
            fixAssetTemplateId: transactionItem.fixedAssetTemplate.id,
            isAcquisitionCost: transactionItem.fixedAssetTemplate.isService,
            fixAssetTemplateCode: transactionItem.fixedAssetTemplate.code,
            assetId: transactionItem.fixedAsset.id,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            sequenceNumber: 0,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
            referenceQuotationItem: {
              referenceQuotationItemId: transactionItem.referenceQuotationItemId,
            },
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      expenseType: transaction.expenseType,
      transaction: transactionCreate,
    };
  },
  GetCreateReceiptInputOld(status, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          assetTemplateId: transactionItem.fixedAssetTemplate.id,
          assetId: transactionItem.fixedAsset.id,
          description: transactionItem.description.text,
          price: transactionItem.price.value.ToNumber(),
          amount: transactionItem.amount.value.ToNumber(),
          discount: transactionItem.discount.value.ToNumber(),
          vatType: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
          allocationTransactionList: transactionItem.isUseTransactionAllocation
            ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
            : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
        };
        transactionCreate.transactionItemList.push(_transactionItem);
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateCreditNoteInput(status, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      creditNoteReasonId: transaction.reasonType.value.id,
      creditNoteDescription: transaction.reasonDescription.text,
      isReturnStock: transaction.returnStock.value.id == Enums.ReturnStockType.Return ? true : false,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      receivedTaxInvoiceList: [],
      transactionItemList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
      referenceTransactionAmount: summary.transactionSummary.referenceTransactionAmount.ToNumber(),
      referenceTransactionCurrencyAmount: summary.transactionCurrencySummary.referenceTransactionAmount.ToNumber(),
    };
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        receivedTaxInvoiceJournalDate: receivedTaxInvoice.receivedTaxInvoiceJournalDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            assetTemplateId: transactionItem.fixedAssetTemplate.id,
            assetId: transactionItem.fixedAsset.id,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.code,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            referenceTransactionProductId: transactionItem.referenceTransactionProductId,
            sequenceNumber: 0,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
            referenceStockActivityId: transactionItem.referenceStockActivityId,
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateDebitNoteInput(status, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      actionDate: null,
      id: 0,
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      dueDate: transaction.dueDate.value.ToDateJsonString(),
      isVat: false,
      discount: transaction.transactionDiscount.value,
      discountType: transaction.transactionDiscount.discountType,
      remark: transaction.remark.text,
      status: 0,
      contact: {
        id: transaction.contact.id,
        contactCode: transaction.contact.contactCode,
      },
      financeTypeId: transaction.financeType,
      taxStatus: transaction.taxStatus.value,
      isDeleted: false,
      isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
      isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
      referenceName: transaction.reference.referenceName,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      referencePaymentGroupId: transaction.reference.paymentGroupId,
      debitNoteReasonId: transaction.reasonType.value.id,
      debitNoteDescription: transaction.reasonDescription.text,
      isReturnStock: transaction.returnStock.value.id == Enums.ReturnStockType.Return ? true : false,
      transactionSummary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      },
      transactionItemList: [],
      receivedTaxInvoiceList: [],
      payment: ConvertPaymentForCreate(transaction.payment),
      fileList: [],
      tagList: transaction.tagList,
      allocationTransactionList: GetCreateAllocationTransaction(transaction.allocationTransactionList),
      referenceTransactionAmount: summary.transactionSummary.referenceTransactionAmount.ToNumber(),
      referenceTransactionCurrencyAmount: summary.transactionCurrencySummary.referenceTransactionAmount.ToNumber(),
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.checked && transactionItem.checked.value) {
          let _transactionItem = {
            transactionId: 0,
            assetTemplateId: transactionItem.fixedAssetTemplate.id,
            assetId: transactionItem.fixedAsset.id,
            description: transactionItem.description.text,
            price: transactionItem.price.value.ToNumber(),
            amount: transactionItem.amount.value.ToNumber(),
            discount: transactionItem.discount.value.ToNumber(),
            vatType: transactionItem.vatTypeId.value,
            productTemplateId: transactionItem.productTemplate.id,
            productTemplateCode: transactionItem.productTemplate.code,
            discountType: transactionItem.discount.discountTypeId,
            netAmount: transactionItem.itemPreVatTotal.ToNumber(),
            accountId: transactionItem.account.id,
            accountCode: transactionItem.account.code,
            isDescriptionOnly: transactionItem.isDescriptionOnly,
            whtAmount: transactionItem.itemWht.value,
            whtAmountType: transactionItem.itemWht.whtAmountType,
            sequenceNumber: 0,
            referenceTransactionProductId: transactionItem.referenceTransactionProductId,
            allocationTransactionList: transactionItem.isUseTransactionAllocation
              ? GetCreateAllocationTransaction(transaction.allocationTransactionList)
              : GetCreateAllocationTransactionItem(transactionItem.allocationTransactionList),
            referenceStockActivityId: transactionItem.referenceStockActivityId,
          };
          transactionCreate.transactionItemList.push(_transactionItem);
        }
      }
    }
    if (
      transaction.receivedTaxInvoice &&
      transaction.receivedTaxInvoice.value &&
      transaction.receivedTaxInvoice.value.length > 0
    ) {
      let receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
      transactionCreate.receivedTaxInvoiceList.push({
        receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
        receivedTaxInvoiceJournalDate: receivedTaxInvoice.receivedTaxInvoiceJournalDate,
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vat.vatTotal.ToNumber(),
      });
    }
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transactionCreate.financeTypeId,
      transaction: transactionCreate,
      transactionItemType: transaction.transactionItemType,
    };
  },
  GetCreateTaxInvoiceInput(status, transaction) {
    let transactionCreate = {
      number: transaction.number.value,
      date: transaction.date.value.ToDateJsonString(),
      remark: transaction.remark.text,
      status: 0,
      referenceId: transaction.reference.referenceId,
      referenceType: transaction.reference.referenceTypeId,
      fileList: [],
      tagList: transaction.tagList,
      referenceName: transaction.reference.referenceName,
    };
    if (status != null) {
      transactionCreate.status = status;
    }
    return {
      financeType: transaction.financeType,
      transaction: transactionCreate,
    };
  },
  GetTagList(tagRawList) {
    let tagList = [];
    if (tagRawList && tagRawList.length > 0) {
      for (let tagRaw of tagRawList) {
        tagList.push({
          tagId: tagRaw.tagId,
          tagName: tagRaw.tagName,
        });
      }
    }
    return tagList;
  },
  ConvertToTransactionDetailForCreateTaxInvoice(transactionRaw) {
    let transaction = {
      number: transactionRaw.number,
      date: transactionRaw.date,
      isVat: transactionRaw.isVat,
      discount: transactionRaw.discount,
      remark: transactionRaw.remark,
      status: transactionRaw.status,
      financeTypeId: transactionRaw.financeTypeId,
      taxStatus: transactionRaw.taxStatus,
      referenceName: transactionRaw.referenceName,
      discountType: transactionRaw.discountType,
      transactionSummary: {
        subTotal: transactionRaw.transactionSummary.subTotal,
        netAmount: transactionRaw.transactionSummary.netAmount,
        whtTotal: transactionRaw.transactionSummary.whtTotal,
        vatExemptedTotal: transactionRaw.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transactionRaw.transactionSummary.zeroVatTotal,
        preVatTotal: transactionRaw.transactionSummary.preVatTotal,
        vatTotal: transactionRaw.transactionSummary.vatTotal,
        subTotalForCalculateWht: transactionRaw.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transactionRaw.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transactionRaw.transactionSummary.isServiceOnly,
        sameProductVatType: transactionRaw.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transactionRaw.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transactionRaw.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transactionRaw.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transactionRaw.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transactionRaw.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transactionRaw.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transactionRaw.transactionCurrency.currencyExchangeRates,
        currencyRatio: transactionRaw.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transactionRaw.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transactionRaw.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transactionRaw.transactionCurrency.toCurrencyUid,
        amountBeforeDiscount: 0,
        referenceDepositTotal: 0,
        amountAfterDiscount: 0,
      },
      contact: { id: transactionRaw.contact.id, contactCode: "" },
      tagList: [],
      referenceId: transactionRaw.referenceId,
      referenceType: transactionRaw.referenceType,
      transactionItemList: [],
      billingNoteTransactionList: [],
      isBillingNoteTransaction: transactionRaw.isBillingNoteTransaction,
      transactionItemType: transactionRaw.transactionItemType,
      referenceDepositSummary: ConvertTorReferenceDepositSummaryDetail(transactionRaw),
    };

    if (transactionRaw.tagList) {
      for (let tag of transactionRaw.tagList) {
        transaction.tagList.push({
          tagId: tag.tagId,
        });
      }
    }
    if (transactionRaw.isBillingNoteTransaction && transactionRaw.billingNoteTransactionList) {
      transaction.billingNoteTransactionList = billingNoteHelper.GetBillingNoteTransactionDetailList(
        transactionRaw.billingNoteTransactionList
      );
    } else if (transactionRaw.transactionItemList) {
      for (let transactionItem of transactionRaw.transactionItemList) {
        let transactionItemAmount = 0;
        let transactionItemTotal = 0;
        let transactionItemPrice = 0;
        let transactionItemDiscount = 0;
        let transactionItemPriceTotal = 0;
        let transactionItemPreVatAmount = 0;

        if (!transactionItem.isDescriptionOnly) {
          transactionItemAmount = transactionItem.amount.ToNumber();
          transactionItemPrice = transactionItem.price.ToNumber();
          transactionItemDiscount = transactionItem.discount.ToNumber();
        }

        transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
        transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
        if (transaction.taxStatus === Enums.TaxTypeId.IncludeTax) {
          if (transactionItem.vatType === Enums.ProductVatType.SevenPercent) {
            transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
              peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
              100
            );
          } else {
            transactionItemPreVatAmount = transactionItemTotal;
          }
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
        }

        const transactionItemModel = {
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          accountId: transactionItem.accountId,
          netAmount: transactionItem.netAmount,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          assetId: transactionItem.assetId,
          fixAssetTemplateId: transactionItem.assetTemplateId,
          toCurrencyPreVatTotal: 0,
          toCurrencyZeroVatTotal: 0,
          toCurrencyVatExemptedTotal: 0,
        };

        switch (transactionItemModel.vatType) {
          case Enums.ProductVatType.SevenPercent:
            transactionItemModel.toCurrencyPreVatTotal = transactionItemPreVatAmount;
            break;
          case Enums.ProductVatType.ZeroPercent:
            transactionItemModel.toCurrencyZeroVatTotal = transactionItemTotal;
            break;
          case Enums.ProductVatType.None:
            transactionItemModel.toCurrencyVatExemptedTotal = transactionItemTotal;
            break;
        }

        transaction.transactionCurrency.amountBeforeDiscount +=
          transactionItemModel.toCurrencyPreVatTotal +
          transactionItemModel.toCurrencyZeroVatTotal +
          transactionItemModel.toCurrencyVatExemptedTotal;

        transaction.transactionItemList.push(transactionItemModel);
      }
    }

    transaction.transactionCurrency.referenceDepositTotal = GetReferenceDepositTotalDetail(transactionRaw);
    transaction.transactionCurrency.amountAfterDiscount = GetAmountAfterDiscountDetail(
      transaction.transactionCurrency.amountBeforeDiscount,
      transaction.transactionCurrency.referenceDepositTotal,
      transaction.discount,
      transaction.discountType
    );
    return transaction;
  },
  ConvertToTransactionListForCreateTaxInvoice(transactionRawList, transactionType) {
    let transactionList = [];
    if (transactionRawList) {
      for (let transactionRaw of transactionRawList) {
        transactionList.push({
          referenceName: transactionRaw.number,
          referenceId: transactionRaw.id,
          referenceType: transactionType,
        });
      }
    }
    return transactionList;
  },
  GetFromAndToDate(month, year) {
    return {
      fromDate: new Date(year, month - 1, 1),
      toDate: new Date(year, month, 0),
    };
  },
  ConvertToTransactionDetail(_transaction) {
    return ConvertToTransactionDetail(_transaction);
  },
  ConvertToFileList(_fileList) {
    let fileList = [];
    if (_fileList.length > 0) {
      _fileList.forEach((item) => {
        fileList.push({
          id: item.id,
          fileName: item.fileName,
          fileFullUrl: item.fileUrl,
          fileType: item.fileType ? item.fileType : "",
          createDateTime: item.createDateTime,
          userId: item.userId,
          checkSendEmail: false,
        });
      });
    }
    return fileList;
  },
  ConvertToTagDetail(_tagDetail) {
    let tagDetail = [];
    if (_tagDetail.length > 0) {
      _tagDetail.forEach((item) => {
        tagDetail.push({
          tagId: item.tagId,
          tagName: item.tagName,
          transactionId: item.transactionId,
          transactionType: item.transactionType,
        });
      });
    }
    return tagDetail;
  },
  ConvertToPurchaseRequisitionDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToQuotationDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.actionDate = transactionRawData.actionDate;
    transaction.rejectDate = transactionRawData.rejectDate;
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.quotationReferenceTransactionType = transactionRawData.quotationReferenceTransactionType;

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }

    transaction.transactionSummary.referenceTransactionToCurrencyNetTotal =
      transactionRawData.referenceTransactionToCurrencyNetTotal;

    return transaction;
  },
  ConvertToPurchaseOrderDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.quotationReferenceTransactionType = transactionRawData.quotationReferenceTransactionType;

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }

    transaction.transactionSummary.referenceTransactionToCurrencyNetTotal =
      transactionRawData.referenceTransactionToCurrencyNetTotal;

    return transaction;
  },
  ConvertToPurchaseOrderAssetDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.quotationReferenceTransactionType = transactionRawData.quotationReferenceTransactionType;

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.assetTemplateId = transactionItemRawData.assetTemplateId;
        transactionItemTemplate.fixAssetTemplateCode = "";
        transactionItemTemplate.isAcquisitionCost = transactionItemRawData.isAcquisitionCost;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }

    transaction.transactionSummary.referenceTransactionToCurrencyNetTotal =
      transactionRawData.referenceTransactionToCurrencyNetTotal;

    return transaction;
  },
  ConvertToDepositDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToReceivedDepositDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(transactionRawData.receivedTaxInvoiceList);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToGoodsReceiptDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToInvoiceReceiptDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(transactionRawData.receivedTaxInvoiceList);
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToInvoiceDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToInvoiceSaleAssetDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.assetId = transactionItemRawData.assetId;
        transactionItemTemplate.assetTemplateId = transactionItemRawData.assetTemplateId;
        transactionItemTemplate.fixAssetTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToPurchaseInventoryDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(transactionRawData.receivedTaxInvoiceList);
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToPurchaseAssetDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(transactionRawData.receivedTaxInvoiceList);
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.assetTemplateId = transactionItemRawData.assetTemplateId;
        transactionItemTemplate.fixAssetTemplateCode = "";
        transactionItemTemplate.isAcquisitionCost = transactionItemRawData.isAcquisitionCost;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToReceiptDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.referencePaymentGroupId = transactionRawData.referencePaymentGroupId;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);
    if (transaction.referenceType == Enums.ReceiptReferenceType.BillingNote) {
      transaction.isBillingNoteTransaction = true;
      transaction.billingNoteTransactionList = billingNoteHelper.GetBillingNoteTransactionDetailList(
        transactionRawData.billingNoteTransactionList
      );
    }
    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
      transaction.paidTotal = transaction.transactionSummary.netAmount;
      transaction.transactionSummary.remainPaymentNetAmount = 0;
      transaction.transactionSummary.remainWhtPaymentNetAmount = 0;
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.productTemplateId = transactionItemRawData.productTemplateId;
        transactionItemTemplate.productTemplateName = "";
        transactionItemTemplate.productTemplateCode = "";
        transactionItemTemplate.stockActivityId = transactionItemRawData.stockActivityId;
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToReceiptSaleAssetDetail(transactionRawData) {
    const transaction = ConvertToTransactionDetailBaseModel(transactionRawData);
    transaction.dueDate = transactionRawData.dueDate;
    transaction.transactionStatus = transactionRawData.status;
    transaction.referenceId = transactionRawData.referenceTransactionId;
    transaction.referenceType = transactionRawData.referenceTransactionType;
    transaction.referenceNumber = transactionRawData.referenceName;
    transaction.referenceContactId = 0;
    transaction.referencePaymentGroupId = transactionRawData.referencePaymentGroupId;
    transaction.isCreatedTaxInvoice = transactionRawData.isCreatedTaxInvoice;
    transaction.isTaxDocument = transactionRawData.isTaxDocument;
    transaction.pp30Id = transactionRawData.pp30Id;
    transaction.pp30Number = transactionRawData.pp30Number;
    transaction.isSendETaxInvoice = transactionRawData.isSendETaxInvoice;
    transaction.eTaxInvoiceId = transactionRawData.eTaxInvoiceId;
    transaction.isFetchedDataToPeakTax = transactionRawData.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = transactionRawData.isFiledFromPeakTax;
    transaction.referenceDepositList = ConvertToReferenceDepositListDetail(transactionRawData.referenceDepositList);
    transaction.referenceDepositSummary = ConvertTorReferenceDepositSummaryDetail(transactionRawData);

    if (transactionRawData.remainPaymentDetail) {
      SetRemainPaymentDetail(transaction, transactionRawData);
      transaction.paidTotal = transaction.transactionSummary.netAmount;
      transaction.transactionSummary.remainPaymentNetAmount = 0;
      transaction.transactionSummary.remainWhtPaymentNetAmount = 0;
    }

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercentNewModel(
        transactionRawData.taxStatus,
        transactionRawData.transactionItemList
      );

    const allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transactionRawData.toCurrency.discount,
      transactionRawData.discountType,
      transactionRawData.taxStatus
    );

    if (transactionRawData.transactionItemList && transactionRawData.transactionItemList.length > 0) {
      transactionRawData.transactionItemList.forEach((transactionItemRawData) => {
        const transactionItemTemplate = ConvertToTransactionItemDetailBaseModel(
          transactionRawData,
          transactionItemRawData,
          allocateDiscountPercent
        );
        transactionItemTemplate.accountId = transactionItemRawData.accountId;
        transactionItemTemplate.assetId = transactionItemRawData.assetId;
        transactionItemTemplate.assetTemplateId = transactionItemRawData.assetTemplateId;
        transactionItemTemplate.fixAssetTemplateCode = "";
        transactionItemTemplate.referenceQuotationItemId = transactionItemRawData.referenceQuotationItemId;
        transaction.transactionItems.push(transactionItemTemplate);
      });
    }
    return transaction;
  },
  ConvertToTaxInvoiceDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.transactionItemType = _transaction.transactionItemType;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.isAutoGenerated = _transaction.isAutoGenerated;
    if (_transaction.referenceReceiptBillingNoteId > 0) {
      transaction.isBillingNoteTransaction = true;
      transaction.billingNoteTransactionList = billingNoteHelper.GetBillingNoteTransactionDetailList(
        _transaction.billingNoteTransactionList
      );
    }
    return transaction;
  },
  ConvertToCreditNoteDetail(_transaction) {
    let transaction = this.ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.creditNoteStyleType = _transaction.creditNoteStyleType;
    transaction.referencePaymentDocumentCount = _transaction.referencePaymentDocumentCount;
    transaction.referencePaymentDocumentTotal = _transaction.referencePaymentDocumentTotal;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.referencePaymentDocumentTotalAwaitPaid = 0;
    transaction.paidTotal = _transaction.paidTotal;
    transaction.paymentCount = _transaction.paymentCount;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
    transaction.creditNoteReasonId = _transaction.creditNoteReasonId ? _transaction.creditNoteReasonId : 1;
    transaction.creditNoteDescription = _transaction.creditNoteDescription ? _transaction.creditNoteDescription : "";
    transaction.isReturnStock = _transaction.isReturnStock ? _transaction.isReturnStock : false;
    transaction.referenceTransactionAmount = _transaction.referenceTransactionAmount;
    transaction.referenceTransactionCurrencyAmount = _transaction.referenceTransactionCurrencyAmount;
    transaction.referenceTransactionCurrencyVatTotal = _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionVatTotal = _transaction.referenceTransactionVatTotal;
    transaction.referenceTransactionCurrencySubTotal =
      _transaction.referenceTransactionCurrencyAmount - _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionSubTotal =
      _transaction.referenceTransactionNetAmount - _transaction.referenceTransactionVatTotal;
    return transaction;
  },
  ConvertToDebitNoteDetail(_transaction) {
    let transaction = this.ConvertToTransactionDetail(_transaction);
    transaction.referenceId = _transaction.referenceId;
    transaction.referenceNumber = _transaction.referenceNumber;
    transaction.referenceType = _transaction.referenceType;
    transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
    transaction.isTaxDocument = _transaction.isTaxDocument;
    transaction.isSendETaxInvoice = _transaction.isSendETaxInvoice;
    transaction.eTaxInvoiceId = _transaction.eTaxInvoiceId;
    transaction.creditNoteStyleType = _transaction.creditNoteStyleType;
    transaction.billedTotalAwaitPaidPayment = _transaction.billedTotalAwaitPaidPayment;
    transaction.billedCount = _transaction.billedCount;
    transaction.billedTotal = _transaction.billedTotal;
    transaction.billedWhtTotal = _transaction.billedWhtTotal;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.referencePaymentDocumentTotalAwaitPaid = 0;
    transaction.paidTotal = _transaction.paidTotal;
    transaction.paymentCount = _transaction.paymentCount;
    transaction.pp30Id = _transaction.pp30Id;
    transaction.pp30Number = _transaction.pp30Number;
    transaction.isFetchedDataToPeakTax = _transaction.isFetchedDataToPeakTax;
    transaction.isFiledFromPeakTax = _transaction.isFiledFromPeakTax;
    transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
    transaction.debitNoteReasonId = _transaction.debitNoteReasonId ? _transaction.debitNoteReasonId : 1;
    transaction.debitNoteDescription = _transaction.debitNoteDescription ? _transaction.debitNoteDescription : "";
    transaction.isReturnStock = _transaction.isReturnStock ? _transaction.isReturnStock : false;
    transaction.referenceTransactionAmount = _transaction.referenceTransactionAmount;
    transaction.referenceTransactionCurrencyAmount = _transaction.referenceTransactionCurrencyAmount;
    transaction.referenceTransactionCurrencyVatTotal = _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionNetAmount = _transaction.referenceTransactionNetAmount;
    transaction.referenceTransactionVatTotal = _transaction.referenceTransactionVatTotal;
    transaction.referenceTransactionCurrencySubTotal =
      _transaction.referenceTransactionCurrencyAmount - _transaction.referenceTransactionCurrencyVatTotal;
    transaction.referenceTransactionSubTotal =
      _transaction.referenceTransactionNetAmount - _transaction.referenceTransactionVatTotal;
    transaction.dueDate = _transaction.transactionDueDate;
    return transaction;
  },
  async ConvertToBillingNoteDetail(_transaction) {
    let transaction = ConvertToTransactionDetail(_transaction);
    transaction.isBillingNoteTransaction = true;
    transaction.billedTotalAwaitPaidPayment = 0;
    transaction.billedCount = 0;
    transaction.creditNoteCount = 0;
    transaction.creditNoteTotal = 0;
    transaction.referencePaymentDocumentTotalAwaitPaid = 0;
    transaction.paidTotal = 0;
    transaction.paidCount = 0;
    transaction.referenceName = _transaction.receivedBilligNoteNumber;
    transaction.receivedBilligNoteNumber = _transaction.receivedBilligNoteNumber;
    transaction.referencePaymentDocumentCount = _transaction.referencePaymentDocumentCount;
    transaction.referencePaymentDocumentTotal = _transaction.referencePaymentDocumentTotal;
    transaction.billingNoteTransactionList = billingNoteHelper.GetBillingNoteTransactionDetailList(
      _transaction.transactionItemList
    );
    transaction.billingNoteTransactionListDefault = [];
    transaction.billingNoteTransactionListDefault.push(...transaction.billingNoteTransactionList);
    transaction.isShowTransactionItem = _transaction.isShowTransactionItem;
    transaction.payment = await ConvertPaymentFromPaymentModel(_transaction.payment, false);
    if (
      _transaction.payment &&
      _transaction.payment.paymentGroupList &&
      _transaction.payment.paymentGroupList.length > 0
    ) {
      transaction.isNotSuggestionPayment = true;
    }
    return transaction;
  },
  async ConvertReceiptBillingNoteCreate(transactionRaw) {
    let paymentDisabled =
      transactionRaw.payment &&
      transactionRaw.payment.paymentGroupList &&
      transactionRaw.payment.paymentGroupList.length > 0;
    let receipt = {
      referenceName: transactionRaw.referenceName,
      referenceId: transactionRaw.referenceId.ToNumber(),
      referenceType: transactionRaw.referenceType,
      paymentGroupId: transactionRaw.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transactionRaw.transactionSummary.subTotal,
        netAmount: transactionRaw.transactionSummary.netAmount,
        whtTotal: transactionRaw.transactionSummary.whtTotal,
        vatExemptedTotal: transactionRaw.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transactionRaw.transactionSummary.zeroVatTotal,
        preVatTotal: transactionRaw.transactionSummary.preVatTotal,
        vatTotal: transactionRaw.transactionSummary.vatTotal,
        subTotalForCalculateWht: transactionRaw.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transactionRaw.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transactionRaw.transactionSummary.isServiceOnly,
        sameProductVatType: transactionRaw.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transactionRaw.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transactionRaw.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transactionRaw.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transactionRaw.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transactionRaw.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transactionRaw.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transactionRaw.transactionCurrency.currencyExchangeRates,
        currencyRatio: transactionRaw.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transactionRaw.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transactionRaw.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transactionRaw.transactionCurrency.toCurrencyUid,
      },
      contact: { id: transactionRaw.contact.id, contactCode: "" },
      billingNoteTransactionList: [],
      isBillingNoteTransaction: true,
      payment: await ConvertPaymentFromPaymentModel(transactionRaw.payment, paymentDisabled),
    };
    if (transactionRaw.billingNoteTransactionList) {
      receipt.transactionCurrency.currencyExchangeRates =
        transactionRaw.billingNoteTransactionList[0].currency.exchangeRates;
      receipt.transactionCurrency.currencyRatio = transactionRaw.billingNoteTransactionList[0].currency.ratio;
      receipt.billingNoteTransactionList = billingNoteHelper.GetBillingNoteTransactionDetailList(
        transactionRaw.billingNoteTransactionList
      );
    }

    return receipt;
  },
  ConvertToBillingNoteTransactionInvoiceDetail(transactionId, billingNoteTransactionRawList) {
    let billingNoteTransactionList = [];
    if (billingNoteTransactionRawList) {
      billingNoteTransactionRawList.forEach((billingTransactionRaw) => {
        billingNoteTransactionList.push({
          transactionId: transactionId,
          transactionType: Enums.TransactionType.Invoice,
          actionDate: billingTransactionRaw.actionDate,
          billedAmount: billingTransactionRaw.billedAmount,
          billedWHT: billingTransactionRaw.billedWHT,
          billingNoteId: billingTransactionRaw.billingNoteId,
          billingNoteNumber: billingTransactionRaw.billingNoteNumber,
          billingNoteTransactionId: billingTransactionRaw.billingNoteTransactionId,
          dueDate: billingTransactionRaw.dueDate,
          financeType: billingTransactionRaw.financeType,
          transactionNetAmount: billingTransactionRaw.invoiceNetAmount,
          transactionSubTotal: billingTransactionRaw.invoiceSubTotal,
          paymentModel: billingTransactionRaw.paymentModel,
          status: billingTransactionRaw.status,
          transactionStatus: billingTransactionRaw.transactionStatus,
          uuid: billingTransactionRaw.uuid,
          paymentSummary: {},
        });
      });
    }
    return billingNoteTransactionList;
  },
  ConvertToBillingNoteTransactionDebitNoteDetail(transactionId, billingNoteTransactionRawList) {
    let billingNoteTransactionList = [];
    if (billingNoteTransactionRawList) {
      billingNoteTransactionRawList.forEach((billingTransactionRaw) => {
        billingNoteTransactionList.push({
          transactionId: transactionId,
          transactionType: Enums.TransactionType.DebitNote,
          actionDate: billingTransactionRaw.actionDate,
          billedAmount: billingTransactionRaw.billedAmount,
          billedWHT: billingTransactionRaw.billedWHT,
          billingNoteId: billingTransactionRaw.billingNoteId,
          billingNoteNumber: billingTransactionRaw.billingNoteNumber,
          billingNoteTransactionId: billingTransactionRaw.billingNoteTransactionId,
          dueDate: billingTransactionRaw.dueDate,
          financeType: billingTransactionRaw.financeType,
          transactionNetAmount: billingTransactionRaw.debitNoteNetAmount,
          transactionSubTotal: billingTransactionRaw.debitNoteSubTotal,
          paymentModel: billingTransactionRaw.paymentModel,
          status: billingTransactionRaw.status,
          transactionStatus: billingTransactionRaw.transactionStatus,
          uuid: billingTransactionRaw.uuid,
          paymentSummary: {},
        });
      });
    }
    return billingNoteTransactionList;
  },
  ConvertToBillingNoteTransactionDepositDetail(transactionId, billingNoteTransactionRawList) {
    let billingNoteTransactionList = [];
    if (billingNoteTransactionRawList) {
      billingNoteTransactionRawList.forEach((billingTransactionRaw) => {
        billingNoteTransactionList.push({
          transactionId: transactionId,
          transactionType: Enums.TransactionType.Deposit,
          actionDate: billingTransactionRaw.actionDate,
          billedAmount: billingTransactionRaw.billedAmount,
          billedWHT: billingTransactionRaw.billedWHT,
          billingNoteId: billingTransactionRaw.billingNoteId,
          billingNoteNumber: billingTransactionRaw.billingNoteNumber,
          billingNoteTransactionId: billingTransactionRaw.billingNoteTransactionId,
          dueDate: billingTransactionRaw.dueDate,
          financeType: billingTransactionRaw.financeType,
          transactionNetAmount: billingTransactionRaw.depositNetAmount,
          transactionSubTotal: billingTransactionRaw.depositSubTotal,
          paymentModel: billingTransactionRaw.paymentModel,
          status: billingTransactionRaw.status,
          transactionStatus: billingTransactionRaw.transactionStatus,
          uuid: billingTransactionRaw.uuid,
          paymentSummary: {},
        });
      });
    }
    return billingNoteTransactionList;
  },
  ConvertToBillingNoteTransactionInvoiceReceiptDetail(transactionId, billingNoteTransactionRawList) {
    let billingNoteTransactionList = [];
    if (billingNoteTransactionRawList) {
      billingNoteTransactionRawList.forEach((billingTransactionRaw) => {
        billingNoteTransactionList.push({
          transactionId: transactionId,
          transactionType: Enums.TransactionType.InvoiceReceipt,
          actionDate: billingTransactionRaw.actionDate,
          billedAmount: billingTransactionRaw.billedAmount,
          billedWHT: billingTransactionRaw.billedWHT,
          billingNoteId: billingTransactionRaw.billingNoteId,
          billingNoteNumber: billingTransactionRaw.billingNoteNumber,
          billingNoteTransactionId: billingTransactionRaw.billingNoteTransactionId,
          dueDate: billingTransactionRaw.dueDate,
          financeType: billingTransactionRaw.financeType,
          transactionNetAmount: billingTransactionRaw.invoiceReceiptNetAmount,
          transactionSubTotal: billingTransactionRaw.invoiceReceiptSubTotal,
          paymentModel: billingTransactionRaw.paymentModel,
          status: billingTransactionRaw.status,
          transactionStatus: billingTransactionRaw.transactionStatus,
          uuid: billingTransactionRaw.uuid,
          paymentSummary: {},
        });
      });
    }
    return billingNoteTransactionList;
  },
  async ConvertToReceiptEdit(transaction) {
    let paymentDisabled =
      (transaction.referenceType === Enums.TransactionType.BillingNote ||
        transaction.referenceType === Enums.TransactionType.Invoice) &&
      transaction.referencePaymentGroupId != 0;
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contactId: transaction.contact.id,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceContactId: 0,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      referencePaymentGroupId: transaction.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
        amountBeforeDiscount: 0,
        referenceDepositTotal: 0,
        amountAfterDiscount: 0,
      },
      transactionItems: [],
      billingNoteTransactionList: billingNoteHelper.GetBillingNoteTransactionDetailList(
        transaction.billingNoteTransactionList
      ),
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, paymentDisabled),
      isNotSuggestionPayment: false,
      allocationList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
      transactionItemType: transaction.transactionItemType,
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
    }

    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code ? transactionItem.code : transactionItem.productTemplateCode,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          assetId: transactionItem.assetId,
          fixAssetTemplateId: transactionItem.assetTemplateId,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
        };
        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItems.push(_transactionItem);
      }
    }

    transactionEdit.transactionCurrency.amountBeforeDiscount = GetAmountBeforeDiscountDetail(transaction);
    transactionEdit.transactionCurrency.referenceDepositTotal = GetReferenceDepositTotalDetail(transaction);
    transactionEdit.transactionCurrency.amountAfterDiscount = GetAmountAfterDiscountDetail(
      transactionEdit.transactionCurrency.amountBeforeDiscount,
      transactionEdit.transactionCurrency.referenceDepositTotal,
      transactionEdit.discount,
      transactionEdit.discountType
    );
    return transactionEdit;
  },
  async ConvertToRecurringReceiptForDetail(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
      },
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      referencePaymentGroupId: transaction.referencePaymentGroupId,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      billingNoteTransactionList: billingNoteHelper.GetBillingNoteTransactionDetailList(
        transaction.billingNoteTransactionList
      ),
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, true),
      isNotSuggestionPayment: false,
      allocationList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };

    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
    }

    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
        };

        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  ConvertToCreditNoteSummaryList(_creditNoteSummaryList) {
    let creditNoteSummaryList = [];
    if (_creditNoteSummaryList !== null && _creditNoteSummaryList.length > 0) {
      _creditNoteSummaryList.forEach((creditNoteSummaryItem) => {
        creditNoteSummaryList.push({
          creditNoteId: creditNoteSummaryItem.creditNoteId,
          date: creditNoteSummaryItem.date,
          number: creditNoteSummaryItem.number,
          netAmount: creditNoteSummaryItem.netAmount,
          lockStatusId: creditNoteSummaryItem.lockStatusId,
          lockDateTime: creditNoteSummaryItem.lockDateTime,
          lockUserId: creditNoteSummaryItem.lockUserId,
          deductedAmount: creditNoteSummaryItem.deductedAmount,
          returnAmount: creditNoteSummaryItem.returnAmount,
          reasonId: creditNoteSummaryItem.reasonId,
          reasonDescription: creditNoteSummaryItem.reasonDescription,
          isReturnStock: creditNoteSummaryItem.isReturnStock,
          referencedJournal: [],
          paymentSummary: {},
          transactionTypeId: creditNoteSummaryItem.transactionTypeId,
          status: creditNoteSummaryItem.status,
        });
      });
    }
    return creditNoteSummaryList;
  },
  ConvertToDebitNoteSummaryList(_debitNoteSummaryList) {
    let debitNoteSummaryList = [];
    if (_debitNoteSummaryList !== null && _debitNoteSummaryList.length > 0) {
      _debitNoteSummaryList.forEach((debitNoteSummaryItem) => {
        debitNoteSummaryList.push({
          debitNoteId: debitNoteSummaryItem.debitNoteId,
          date: debitNoteSummaryItem.date,
          number: debitNoteSummaryItem.number,
          netAmount: debitNoteSummaryItem.netAmount,
          lockStatusId: debitNoteSummaryItem.lockStatusId,
          lockDateTime: debitNoteSummaryItem.lockDateTime,
          lockUserId: debitNoteSummaryItem.lockUserId,
          addAmount: debitNoteSummaryItem.addAmount,
          returnAmount: debitNoteSummaryItem.returnAmount,
          reasonId: debitNoteSummaryItem.reasonId,
          reasonDescription: debitNoteSummaryItem.reasonDescription,
          isReturnStock: debitNoteSummaryItem.isReturnStock,
          referencedJournal: [],
          paymentSummary: {},
          transactionTypeId: debitNoteSummaryItem.transactionTypeId,
        });
      });
    }
    return debitNoteSummaryList;
  },
  ConvertToTransactionForDoPaidPayment(_transaction) {
    let transaction = {
      id: _transaction.id,
      number: _transaction.number,
      date: _transaction.date,
      contactId: _transaction.contactId,
      transactionType: _transaction.transactionType,
      financeType: _transaction.financeType,
      expenseType: _transaction.expenseType,
      isCreatedTaxInvoice: _transaction.isCreatedTaxInvoice,
      transactionSummary: {
        preVatTotal: _transaction.transactionSummary.preVatTotal,
        zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
        vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
        taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
        vatTotal: _transaction.transactionSummary.vatTotal,
        subTotal: _transaction.transactionSummary.subTotal,
        netAmount: _transaction.transactionSummary.netAmount,
        subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
        whtTotal: _transaction.transactionSummary.whtTotal,
        remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
        remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
        isAllNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: _transaction.transactionSummary.isServiceOnly,
        sameProductVatType: _transaction.transactionSummary.sameProductVatType,
      },
    };
    if (_transaction.transactionItemList && _transaction.transactionItemList.length > 0) {
      transaction.transactionItemList = [];
      for (let transactionItem of _transaction.transactionItemList) {
        if (!transactionItem.isDescriptionOnly) {
          transaction.transactionItemList.push({
            accountId: transactionItem.accountId,
            quantity: transactionItem.amount,
            toCurrencyPrice: transactionItem.price,
            discountType: transactionItem.discountType,
            toCurrencyDiscount: transactionItem.discount,
            vatType: transactionItem.vatType,
            toCurrencyWHTTotal: transactionItem.whtAmount,
            whtAmountType: transactionItem.whtAmountType,
          });
        }
      }
    }
    return transaction;
  },
  ConvertToBillingNoteForDoPaidPayment(_transaction) {
    let transaction = {
      id: _transaction.id,
      number: _transaction.number,
      date: _transaction.date,
      contactId: _transaction.contactId,
      transactionType: _transaction.transactionType,
      financeType: _transaction.financeType,
      expenseType: _transaction.expenseType,
      isCreatedTaxInvoice: _transaction.isCreatedTaxInvoice,
      transactionSummary: {
        preVatTotal: _transaction.transactionSummary.preVatTotal,
        zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
        vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
        taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
        vatTotal: _transaction.transactionSummary.vatTotal,
        subTotal: _transaction.transactionSummary.subTotal,
        netAmount: _transaction.transactionSummary.netAmount,
        subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
        whtTotal: _transaction.transactionSummary.whtTotal,
        remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
        remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
        isNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: _transaction.transactionSummary.isServiceOnly,
        sameProductVatType: _transaction.transactionSummary.sameProductVatType,
      },
    };
    if (_transaction.transactionItemList && _transaction.transactionItemList.length > 0) {
      transaction.transactionItemList = [];
      for (let transactionItem of _transaction.transactionItemList) {
        transaction.transactionItemList.push(transactionItem);
      }
    }
    return transaction;
  },
  ConvertPaymentForCreate(paymentRaw) {
    return ConvertPaymentForCreate(paymentRaw);
  },
  ConvertToQuotationTimeline(timelineRaw) {
    let timeline = {
      invoiceList: [],
      receiptList: ConvertToTransactionTimelineReceiptWithJournal(timelineRaw.receiptList),
    };
    if (timelineRaw.invoiceList) {
      for (let invoiceRaw of timelineRaw.invoiceList) {
        let invoice = {
          invoiceId: invoiceRaw.invoiceId,
          invoiceNumber: invoiceRaw.invoiceNumber,
          invoiceIsCreatedTaxInvoice: invoiceRaw.invoiceIsCreatedTaxInvoice,
          invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
          taxInvoiceId: invoiceRaw.taxInvoiceId,
          taxInvoiceNumber: invoiceRaw.taxInvoiceNumber,
          journalList: ConvertToTransactionTimelineJournal(invoiceRaw.journalList),
          receiptList: ConvertToTransactionTimelineReceipt(invoiceRaw.receiptList),
          billingNoteList: ConvertToTransactionTimelineInvoiceBillingNote(invoiceRaw.billingNoteList),
        };
        timeline.invoiceList.push(invoice);
      }
    }
    return timeline;
  },
  ConvertToDepositTimeline(timelineRaw) {
    let timeline = {
      depositIsCreatedTaxInvoice: timelineRaw.depositIsCreatedTaxInvoice,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      taxInvoiceNumber: timelineRaw.taxInvoiceNumber,
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      billingNoteList: ConvertToTransactionTimelineInvoiceBillingNote(timelineRaw.billingNoteList),
      creditNoteList: ConvertToTransactionTimelineInvoiceCreditNote(timelineRaw.creditNoteList),
    };
    return timeline;
  },
  ConvertToInvoiceTimeline(timelineRaw) {
    let timeline = {
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      taxInvoiceNumber: timelineRaw.taxInvoiceNumber,
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      receiptList: ConvertToTransactionTimelineReceipt(timelineRaw.receiptList),
      billingNoteList: ConvertToTransactionTimelineInvoiceBillingNote(timelineRaw.billingNoteList),
      creditNoteList: ConvertToTransactionTimelineInvoiceCreditNote(timelineRaw.creditNoteList),
    };
    return timeline;
  },
  ConvertToReceiptTimeline(timelineRaw) {
    let timeline = {
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      invoiceId: timelineRaw.invoiceId,
      invoiceNumber: timelineRaw.invoicenNumber,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      taxInvoiceNumber: timelineRaw.taxInvoiceNumber,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptReferenceType: timelineRaw.receiptReferenceType,
      billingNoteId: timelineRaw.billingNoteId,
      billingNoteNumber: timelineRaw.billingNoteNumber,
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
    };
    return timeline;
  },
  ConvertToCreditNoteTimeline(timelineRaw) {
    let timeline = {
      invoiceId: timelineRaw.invoiceId,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceTaxInvoiceId: timelineRaw.invoiceTaxInvoiceId,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptId: timelineRaw.receiptId,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      receiptTaxInvoiceId: timelineRaw.receiptTaxInvoiceId,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
      depositId: timelineRaw.depositId,
      depositIsCreatedTaxInvoice: timelineRaw.depositIsCreatedTaxInvoice,
      depositTaxInvoiceId: timelineRaw.depositTaxInvoiceId,
      depositIssuedIsTaxDocument: timelineRaw.depositIssuedIsTaxDocument,
    };
    return timeline;
  },
  ConvertToDebitNoteTimeline(timelineRaw) {
    let timeline = {
      invoiceId: timelineRaw.invoiceId,
      receiptId: timelineRaw.receiptId,
      receiptIsCreatedTaxInvoice: timelineRaw.receiptIsCreatedTaxInvoice,
      taxInvoiceId: timelineRaw.taxInvoiceId,
      invoiceIsCreatedTaxInvoice: timelineRaw.invoiceIsCreatedTaxInvoice,
      invoiceIssuedIsTaxDocument: timelineRaw.invoiceIssuedIsTaxDocument,
      receiptIssuedIsTaxDocument: timelineRaw.receiptIssuedIsTaxDocument,
    };
    return timeline;
  },
  ConvertToTaxInvoiceTimeline(timelineRaw) {
    let timeline = {
      quotationId: timelineRaw.quotationId,
      quotationNumber: timelineRaw.quotationNumber,
      invoiceId: timelineRaw.invoiceId,
      invoiceNumber: timelineRaw.invoiceNumber,
      receiptId: timelineRaw.receiptId,
      receiptNumber: timelineRaw.receiptNumber,
      receiptReferenceType: timelineRaw.receiptReferenceType,
      billingNoteId: timelineRaw.billingNoteId,
      billingNoteNumber: timelineRaw.billingNoteNumber,
    };
    return timeline;
  },
  ConvertToBillingNoteTimeline(timelineRaw) {
    let timeline = {
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      receiptList: ConvertToTransactionTimelineReceipt(timelineRaw.receiptList),
    };
    return timeline;
  },
  ConvertToPurchaseOrderTimeline(timelineRaw) {
    let timeline = {
      expenseList: [],
    };
    if (timelineRaw.expenseList) {
      for (let expenseRaw of timelineRaw.expenseList) {
        let expense = {
          expenseId: expenseRaw.expenseId,
          expenseNumber: expenseRaw.expenseNumber,
          journalList: ConvertToTransactionTimelineJournal(expenseRaw.journalList),
          combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(expenseRaw.combinePaymentNoteList),
        };
        timeline.expenseList.push(expense);
      }
    }
    return timeline;
  },
  ConvertToExpenseTimeline(timelineRaw) {
    let timeline = {
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(timelineRaw.combinePaymentNoteList),
    };
    return timeline;
  },
  ConvertToPurchaseRequisitionTimeline(timelineRaw) {
    let timeline = {
      quotationList: ConvertToTransactionTimelineQuotation(timelineRaw.quotationList),
      invoiceList: ConvertToTransactionTimelineInvoice(timelineRaw.invoiceList),
    };
    return timeline;
  },
  ConvertToReceivedDepositTimeline(timelineRaw) {
    let timeline = {
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(timelineRaw.combinePaymentNoteList),
    };
    return timeline;
  },
  ConvertToGoodsReceiptTimeline(timelineRaw) {
    let timeline = {
      invoiceReceiptList: ConvertToTransactionTimelineInvoiceReceipt(timelineRaw.invoiceReceiptList),
    };
    return timeline;
  },
  ConvertToInvoiceReceiptTimeline(timelineRaw) {
    let timeline = {
      goodsReceiptList: ConvertToTransactionTimelineGoodsReceipt(timelineRaw.goodsReceiptList),
      journalList: ConvertToTransactionTimelineJournal(timelineRaw.journalList),
      combinePaymentNoteList: ConvertToTransactionTimelineCombinePaymentNote(timelineRaw.combinePaymentNoteList),
    };
    return timeline;
  },
  async ConvertToCreditNoteModel(transaction) {
    let creditNote = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceContactId: 0,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      creditNoteReasonId: transaction.creditNoteReasonId ? transaction.creditNoteReasonId : 0,
      creditNoteDescription: transaction.creditNoteDescription ? transaction.creditNoteDescription : "",
      isReturnStock: transaction.isReturnStock ? transaction.isReturnStock : false,
      creditNoteStyleType: transaction.creditNoteStyleType,
      creditNoteAmount: transaction.creditNoteAmount,
      creditNoteWaitingPaidTotal: transaction.creditNoteWaitingPaidTotal,
      referenceTransactionAmount: transaction.referenceTransactionAmount,
      referenceTransactionCurrencyAmount: transaction.referenceTransactionCurrencyAmount,
      totalDocumentAmountAfterCreditNote: transaction.totalDocumentAmountAfterCreditNote,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      creditNote.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        creditNote.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          remainingAmount: transactionItem.remainingAmount,
          remainingNetAmount: transactionItem.remainingNetAmount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          isReturnStock: transactionItem.isReturnStock,
          referenceTransactionProductId: transactionItem.referenceTransactionProductId,
          allocationTransactionList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            creditNote.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        creditNote.transactionItemList.push(_transactionItem);
      }
    }
    return creditNote;
  },
  async ConvertToDebitNoteModel(transaction) {
    let debitNote = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      userId: transaction.userId,
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceContactId: 0,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      debitNoteReasonId: transaction.debitNoteReasonId,
      debitNoteDescription: transaction.debitNoteDescription,
      isReturnStock: transaction.isReturnStock,
      debitNoteStyleType: transaction.debitNoteStyleType,
      debitNoteAmount: transaction.debitNoteAmount,
      referenceTransactionAmount: transaction.referenceTransactionAmount,
      referenceTransactionCurrencyAmount: transaction.referenceTransactionCurrencyAmount,
      totalDocumentAmountAfterDebitNote: transaction.totalDocumentAmountAfterDebitNote,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationTransactionList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      debitNote.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        debitNote.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }
    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
          referenceStockActivityId: transactionItem.referenceStockActivityId,
          referenceTransactionProductId: transactionItem.referenceTransactionProductId,
        };
        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            debitNote.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        debitNote.transactionItemList.push(_transactionItem);
      }
    }
    return debitNote;
  },
  async ConvertToInvoiceForEdit(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contactId: transaction.contact.id,
      userId: transaction.userId,
      expenseTypeId: transaction.transactionItemType ? transaction.transactionItemType : transaction.expenseTypeId,
      transactionItemType: transaction.transactionItemType
        ? transaction.transactionItemType
        : transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceNumber: transaction.referenceNumber,
      referenceContactId: 0,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItems: [],
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, false),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        transactionEdit.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          assetId: transactionItem.assetId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.code ? transactionItem.code : transactionItem.productTemplateCode,
          fixAssetTemplateId: transactionItem.fixAssetTemplateId,
          fixAssetTemplateCode: transactionItem.code,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isAcquisitionCost: transactionItem.isAcquisitionCost,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
          referenceQuotationItem: {
            discount: transactionItem.referenceQuotationItem.discount,
            discountType: transactionItem.referenceQuotationItem.discountType,
            price: transactionItem.referenceQuotationItem.price,
            referenceQuotationItemId: transactionItem.referenceQuotationItem.referenceQuotationItemId,
            remainingQuantity: transactionItem.referenceQuotationItem.remainingQuantity,
            whtAmount: transactionItem.referenceQuotationItem.whtAmount,
            whtAmountType: transactionItem.referenceQuotationItem.whtAmountType,
          },
        };
        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();
        transactionEdit.transactionItems.push(_transactionItem);
      }
    }
    return transactionEdit;
  },
  async ConvertToRecurringInvoiceForDetail(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      dueDate: transaction.dueDate,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      contact: {
        id: transaction.contact.id,
      },
      expenseTypeId: transaction.expenseTypeId,
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      isCreatedTaxInvoice: transaction.isCreatedTaxInvoice,
      isTaxDocument: transaction.isTaxDocument,
      referenceName: transaction.referenceName,
      referenceId: transaction.referenceId,
      referenceType: transaction.referenceType,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      payment: await ConvertPaymentFromPaymentModel(transaction.payment, true),
      isNotSuggestionPayment: false,
      receivedTaxInvoiceList: ConvertToReceivedIssuedTaxInvoice(transaction.receivedTaxInvoiceList),
      allocationList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
    };
    if (
      transaction.payment &&
      transaction.payment.paymentGroupList &&
      transaction.payment.paymentGroupList.length > 0
    ) {
      transactionEdit.isNotSuggestionPayment = true;
      transaction.payment.paymentGroupList.forEach((element, index) => {
        transactionEdit.payment.paymentGroupList[index].isPaymentActive = element.isPaymentActive;
      });
    }

    let transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
        };
        if (_transactionItem.allocationList && _transactionItem.allocationList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            transactionEdit.allocationList,
            _transactionItem.allocationList
          );
          _transactionItem.isUseTransactionAllocation = allocationTransactionEquals;
        }

        let transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
        let netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }

    return transactionEdit;
  },
  async ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType) {
    return await ConvertToPaymentAndReferenceJournalDetail(paymentRaw, transactionId, transactionType);
  },
  GetCreateBookmarkInput(bookmark, transaction) {
    const transactionItemModel = GetTransactionItemList(transaction);
    SetTransactionItemList(transaction, transactionItemModel);
    const summary = GetTransactionSummary(transaction, transactionItemModel);
    let transactionCreate = {
      id: 0,
      name: bookmark.name.value,
      isRememberContact: bookmark.isRememberContact,
      isRememberAmountAndPrice: bookmark.isRememberAmountAndPrice,
      description: bookmark.description.value,
      transactionType: transaction.transactionType,
      financeType: transaction.financeType,
      transactionTemplateModel: {
        id: 0,
        expenseType: transaction.expenseType,
        taxStatus: transaction.taxStatus.value,
        status: 0,
        remark: transaction.remark.text,
        discount: transaction.transactionDiscount.value.ToNumber(),
        discountType: transaction.transactionDiscount.discountType,
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
        isCreateTaxInvoice: transaction.issueTaxInvoice.value ? 1 : 0,
        isTaxDocument: transaction.issueTaxDocument.value ? 1 : 0,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatTypeId: transaction.transactionSummary.sameProductVatType,
        currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
        currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
        currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
        currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
        currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
        currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
        currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
        currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
        currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
        fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
        toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
        contactId: bookmark.isRememberContact == 1 ? transaction.contact.id : 0,
      },
      transactionTemplateProductModel: [],
    };
    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          transactionId: 0,
          description: transactionItem.description.text,
          price: bookmark.isRememberAmountAndPrice == 1 ? transactionItem.price.value.ToNumber() : 0,
          amount: bookmark.isRememberAmountAndPrice == 1 ? transactionItem.amount.value.ToNumber() : 1,
          discount: transactionItem.discount.value.ToNumber(),
          vatTypeId: transactionItem.vatTypeId.value,
          productTemplateId: transactionItem.productTemplate.id == 0 ? null : transactionItem.productTemplate.id,
          productTemplateCode: transactionItem.productTemplate.code,
          discountType: transactionItem.discount.discountTypeId,
          netAmount: transactionItem.itemPreVatTotal.ToNumber(),
          accountId: transactionItem.account.id,
          accountCode: transactionItem.account.code,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.itemWht.value,
          whtAmountType: transactionItem.itemWht.whtAmountType,
          sequenceNumber: 0,
        };
        transactionCreate.transactionTemplateProductModel.push(_transactionItem);
      }
    }
    return transactionCreate;
  },
  //#region bookmark
  GetBookmarkListInput(input) {
    return {
      merchantId: userInfo.MerchantId(),
      transactionType: input.transactionType,
      financeType: input.financeType,
      expenseType: input.financeType == Enums.FinanceType.InFlow ? 0 : input.expenseType ? input.expenseType : 0,
    };
  },
  GetBookmarkDetailListInput(transactionTemplateId) {
    return {
      merchantId: userInfo.MerchantId(),
      transactionTemplateId: transactionTemplateId,
    };
  },
  GetBookmarkTemplateInput(bookmarkId) {
    return {
      merchantId: userInfo.MerchantId(),
      bookmarkId: bookmarkId,
    };
  },
  GetLatestUserdInput(financeTypeId, expenseTypeId, contactId) {
    return {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
      financeTypeId: financeTypeId,
      expenseTypeId: expenseTypeId,
    };
  },
  DeleteBookmarkInput(bookmarkId) {
    return {
      merchantId: userInfo.MerchantId(),
      bookmarkId: bookmarkId,
    };
  },
  GetBookmarkList(bookmarkOutputList) {
    let bookmarkList = [];
    if (bookmarkOutputList != null) {
      for (let count = 0; count < bookmarkOutputList.length; count++) {
        let bookmarkItem = bookmarkOutputList[count];
        let bookmark = {
          id: bookmarkItem.id,
          name: bookmarkItem.name,
          description: bookmarkItem.description,
          contactId: bookmarkItem.contactId,
          netAmount: bookmarkItem.netAmount,
          isRememberAmountAndPrice: bookmarkItem.isRememberAmountAndPrice,
          transactiontemplateId: bookmarkItem.transactiontemplateId,
          bookmarkDetail: null,
        };
        bookmarkList.push(bookmark);
      }
    }
    return bookmarkList;
  },
  GetBookmarkDetailList(bookmarkDetailOutputList) {
    let bookmarkDetailList = [];
    if (bookmarkDetailOutputList != null) {
      for (let count = 0; count < bookmarkDetailOutputList.length; count++) {
        if (count < 5) {
          let bookmarkDetailItem = bookmarkDetailOutputList[count];
          let bookmark = {
            count: count + 1,
            amount: bookmarkDetailItem.amount,
            descriptionProduct: bookmarkDetailItem.descriptionProduct,
          };
          bookmarkDetailList.push(bookmark);
        }
      }
    }
    return bookmarkDetailList;
  },
  ConvertBookmarkDetailToTransactionDetail(bookmarkModel) {
    let bookmarkTemplate = {
      id: bookmarkModel.id,
      name: bookmarkModel.name,
      isRememberContact: bookmarkModel.isRememberContact,
      isRememberAmountAndPrice: bookmarkModel.isRememberAmountAndPrice,
      description: bookmarkModel.description,
      transactionType: bookmarkModel.transactionType,
      financeType: bookmarkModel.financeType,
      transactionTemplateId: bookmarkModel.transactionTemplateDetailModel.id,
      contactId: bookmarkModel.transactionTemplateDetailModel.contactId,
      contactCode: "",
      expenseType: bookmarkModel.transactionTemplateDetailModel.expenseType,
      taxStatus: bookmarkModel.transactionTemplateDetailModel.taxStatus,
      status: bookmarkModel.transactionTemplateDetailModel.status,
      remark: bookmarkModel.transactionTemplateDetailModel.remark,
      discount: bookmarkModel.transactionTemplateDetailModel.discount,
      discountType: bookmarkModel.transactionTemplateDetailModel.discountType,
      isAllNoneOrNotSpecifyWht: bookmarkModel.transactionTemplateDetailModel.isAllNoneOrNotSpecifyWht,
      isServiceOnly: bookmarkModel.transactionTemplateDetailModel.isServiceOnly,
      netAmount: bookmarkModel.transactionTemplateDetailModel.netAmount,
      subTotal: bookmarkModel.transactionTemplateDetailModel.subTotal,
      preVatTotal: bookmarkModel.transactionTemplateDetailModel.preVatTotal,
      zeroVatTotal: bookmarkModel.transactionTemplateDetailModel.zeroVatTotal,
      vatTotal: bookmarkModel.transactionTemplateDetailModel.vatTotal,
      vatExemtedTotal: bookmarkModel.transactionTemplateDetailModel.vatExemtedTotal,
      subTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.subTotalForCalculateWht,
      whtTotal: bookmarkModel.transactionTemplateDetailModel.whtTotal,
      sameProductVatTypeId: bookmarkModel.transactionTemplateDetailModel.sameProductVatTypeId,
      currencyExchangeRates: bookmarkModel.transactionTemplateDetailModel.currencyExchangeRates,
      fromCurrencyUid: bookmarkModel.transactionTemplateDetailModel.fromCurrencyUid,
      toCurrencyUid: bookmarkModel.transactionTemplateDetailModel.toCurrencyUid,
      currencyRatio: bookmarkModel.transactionTemplateDetailModel.currencyRatio,
      currencyNetAmount: bookmarkModel.transactionTemplateDetailModel.currencyNetAmount,
      currencyPreVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyPreVatTotal,
      currencyZeroVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyZeroVatTotal,
      currencyVatExemptedTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatExemptedTotal,
      currencySubTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.currencySubTotalForCalculateWht,
      currencyVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatTotal,
      currencyWhtTotal: bookmarkModel.transactionTemplateDetailModel.currencyWhtTotal,
      isCreateTaxInvoice: bookmarkModel.transactionTemplateDetailModel.isCreateTaxInvoice,
      transactionItems: [],
    };
    if (
      bookmarkModel.transactionTemplateProductDetailModel &&
      bookmarkModel.transactionTemplateProductDetailModel.length > 0
    ) {
      bookmarkModel.transactionTemplateProductDetailModel.forEach((items) => {
        let bookmarkItemsTemplate = {
          accountCode: items.accountCode,
          productTemplateCode: items.productTemplateCode,
          sequenceNumber: items.sequenceNumber,
          description: items.description,
          isDescriptionOnly: items.isDescriptionOnly,
          productTemplateId: items.productTemplateId,
          accountId: items.accountId,
          price: items.price,
          amount: items.amount,
          discount: items.discount,
          discountType: items.discountType,
          vatType: items.vatTypeId,
          netAmount: items.netAmount,
          whtAmount: items.whtAmount,
          whtAmountType: items.whtAmountTypeId,
          typeId: items.typeId,
        };
        bookmarkTemplate.transactionItems.push(bookmarkItemsTemplate);
      });
    }
    return bookmarkTemplate;
  },
  ConvertToAISuggestionAccountByContact(aiSuggestionTransactionRaw) {
    let aiSuggestionTransaction = {
      isActive: false,
      expenseTypeId: 0,
      transactionId: 0,
      chartOfAccountList: [],
      suggestionAccountMongoId: "",
      financeType: 0,
    };
    if (aiSuggestionTransactionRaw && aiSuggestionTransactionRaw.transactionId > 0) {
      aiSuggestionTransaction.isActive = true;
      aiSuggestionTransaction.transactionId = aiSuggestionTransactionRaw.transactionId;
      aiSuggestionTransaction.expenseTypeId = aiSuggestionTransactionRaw.expenseTypeId;
      aiSuggestionTransaction.financeType = aiSuggestionTransactionRaw.financeType;
    } else if (
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts &&
      aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts.length > 0
    ) {
      aiSuggestionTransaction.isActive = true;
      aiSuggestionTransaction.suggestionAccountMongoId = aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id;
      for (let chartOfAccount of aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts) {
        aiSuggestionTransaction.chartOfAccountList.push({ accountId: chartOfAccount.accountId });
      }
    }
    return aiSuggestionTransaction;
  },
  ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList) {
    return ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList);
  },
  //#endregion
  ConvertToReferenceDocumentPaymentModel(_referenceDocumentPaymentList) {
    let referenceDocumentPaymentList = [];

    if (_referenceDocumentPaymentList && _referenceDocumentPaymentList.length > 0) {
      _referenceDocumentPaymentList.forEach((_referenceDocumentPayment) => {
        let referenceDocumentPayment = {
          id: _referenceDocumentPayment.id,
          transactionType: _referenceDocumentPayment.transactionType,
          number: _referenceDocumentPayment.number,
          remainPayment: _referenceDocumentPayment.remainPayment,
        };
        referenceDocumentPaymentList.push(referenceDocumentPayment);
      });
    }

    return referenceDocumentPaymentList;
  },
  ConvertToTransactionForCreateCreditNoteModel(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      _transactionList.forEach((_transaction) => {
        let transaction = {
          id: _transaction.id,
          number: _transaction.number,
          issueDate: _transaction.issueDate,
        };
        transactionList.push(transaction);
      });
    }
    return transactionList;
  },
  ConvertToTransactionForCreateDebitNoteModel(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      _transactionList.forEach((_transaction) => {
        let transaction = {
          id: _transaction.id,
          number: _transaction.number,
          issueDate: _transaction.issueDate,
        };
        transactionList.push(transaction);
      });
    }
    return transactionList;
  },
  ConvertTransactionItemBaseModelForEasyEdit(productItem, transactionModel) {
    let disabledAccount = false;
    let disabledProductTemplate = false;

    if (transactionModel.transactionType == Enums.TransactionType.TaxInvoice) {
      disabledAccount = true;
      disabledProductTemplate = true;
    } else if (transactionModel.transactionType == Enums.TransactionType.Deposit) {
      disabledAccount = true;
    }

    let baseTransactionItem = transactionHelper.GetCreateTransactionItemDefualt(
      transactionModel.transactionType,
      transactionModel.financeType,
      transactionModel.expenseType
    );

    baseTransactionItem.productTemplate.id = productItem.productTemplateId;
    baseTransactionItem.productTemplate.code = productItem.productTemplateCode;
    baseTransactionItem.productTemplate.name = productItem.productTemplateName;
    baseTransactionItem.productTemplate.disabled = disabledProductTemplate;
    baseTransactionItem.productTemplate.isNotAuto = true;

    baseTransactionItem.id = productItem.id;

    baseTransactionItem.referencePrice = productItem.price.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceAmount = productItem.amount.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceDescription = productItem.description;
    baseTransactionItem.referenceDiscount = productItem.discount.ToPeakTransactionItemFormat();
    baseTransactionItem.referenceDiscountType = productItem.discountType;
    baseTransactionItem.referenceStockActivityId = productItem.referenceStockActivityId;
    baseTransactionItem.isDescriptionOnly = productItem.isDescriptionOnly;

    baseTransactionItem.account.id = productItem.accountId;
    baseTransactionItem.account.code = productItem.accountCode;
    baseTransactionItem.account.isNotAuto = true;
    baseTransactionItem.account.disabled = disabledAccount;

    baseTransactionItem.description.text = productItem.description != null ? productItem.description : "";
    baseTransactionItem.description.disabled = false;
    baseTransactionItem.description.validateError = false;
    baseTransactionItem.amount.value = productItem.amount.ToPeakTransactionItemFormat();
    baseTransactionItem.amount.disabled = false;
    baseTransactionItem.price.value = productItem.price.ToPeakTransactionItemFormat();
    baseTransactionItem.price.disabled = false;
    baseTransactionItem.discount.value = productItem.discount.ToPeakTransactionItemFormat();
    baseTransactionItem.discount.discountTypeId = productItem.discountType;
    baseTransactionItem.discount.disabled = false;
    baseTransactionItem.vatTypeId.value = productItem.vatType;
    baseTransactionItem.vatTypeId.disabled = false;
    baseTransactionItem.itemWht.value = productItem.whtAmount;
    baseTransactionItem.itemWht.whtAmountType = productItem.whtAmountType;
    baseTransactionItem.itemWht.disabled = false;
    if (baseTransactionItem.itemWht.whtAmountType !== 0) {
      baseTransactionItem.itemWht.isNotAuto = true;
    }
    baseTransactionItem.itemNetAmountWithAllocateDiscountTotal = productItem.itemNetAmountWithAllocateDiscountTotal;
    baseTransactionItem.itemNetAmountWithAllocateDiscountForAllocation =
      productItem.itemNetAmountWithAllocateDiscountForAllocation;
    return baseTransactionItem;
  },
  ConvertQuotationToTransactionCreate(transaction) {
    let transactionEdit = {
      id: transaction.id,
      number: transaction.number,
      date: transaction.date,
      isVat: transaction.isVat,
      discount: transaction.discount,
      discountType: transaction.discountType,
      remark: transaction.remark,
      status: transaction.status,
      userId: transaction.userId,
      contact: {
        id: transaction.contact.id,
        contactCode: "",
      },
      financeTypeId: transaction.financeTypeId,
      taxStatus: transaction.taxStatus,
      isDeleted: transaction.isDeleted,
      transactionSummary: {
        subTotal: transaction.transactionSummary.subTotal,
        netAmount: transaction.transactionSummary.netAmount,
        whtTotal: transaction.transactionSummary.whtTotal,
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal,
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal,
        preVatTotal: transaction.transactionSummary.preVatTotal,
        vatTotal: transaction.transactionSummary.vatTotal,
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht,
        isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
        isServiceOnly: transaction.transactionSummary.isServiceOnly,
        sameProductVatType: transaction.transactionSummary.sameProductVatType,
      },
      transactionCurrency: {
        currencyNetAmount: transaction.transactionCurrency.currencyNetAmount,
        currencyZeroVatTotal: transaction.transactionCurrency.currencyZeroVatTotal,
        currencyPreVatTotal: transaction.transactionCurrency.currencyPreVatTotal,
        currencyVatTotal: transaction.transactionCurrency.currencyVatTotal,
        currencySubTotalForCalculateWht: transaction.transactionCurrency.currencySubTotalForCalculateWht,
        currencyWhtTotal: transaction.transactionCurrency.currencyWhtTotal,
        currencyExchangeRates: transaction.transactionCurrency.currencyExchangeRates,
        currencyRatio: transaction.transactionCurrency.currencyRatio,
        currencyVatExemptedTotal: transaction.transactionCurrency.currencyVatExemptedTotal,
        toCurrencyCode: transaction.transactionCurrency.toCurrencyCode,
        fromCurrencyUid: transaction.transactionCurrency.fromCurrencyUid,
        toCurrencyUid: transaction.transactionCurrency.toCurrencyUid,
      },
      transactionItemList: [],
      allocationTransactionList: GetAllocationListWithOutZeroPercent(transaction.allocationTransactionList),
      transactionItemType: transaction.transactionItemType,
      quotationReferenceTransactionType: transaction.type,
      quotationReferenceTransactionRemainingToCurrencyNetTotal: transaction.remainingToCurrencyNetTotal,
    };

    const transactionListForCalculateAllocateDiscountPercent =
      transactionItemHelper.ConvertTransactionListDetailForCalculateAllocateDiscountPercent(
        transaction.taxStatus,
        transaction.transactionItemList
      );

    let allocateDiscountPercent = transactionItemHelper.CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      transaction.discount,
      transaction.discountType,
      transaction.taxStatus
    );

    if (transaction.transactionItemList) {
      for (let transactionItem of transaction.transactionItemList) {
        let _transactionItem = {
          id: transactionItem.id,
          transactionId: transactionItem.transactionId,
          description: transactionItem.description,
          price: transactionItem.price,
          amount: transactionItem.amount,
          discount: transactionItem.discount,
          vatType: transactionItem.vatType,
          productTemplateId: transactionItem.productTemplateId,
          productTemplateCode: transactionItem.productTemplateId > 0 ? transactionItem.code : "",
          discountType: transactionItem.discountType,
          netAmount: transactionItem.netAmount,
          accountId: transactionItem.accountId,
          isDescriptionOnly: transactionItem.isDescriptionOnly,
          whtAmount: transactionItem.whtAmount,
          whtAmountType: transactionItem.whtAmountType,
          assetTemplateId: transactionItem.assetTemplateId,
          assetId: transactionItem.assetId,
          fixAssetTemplateCode: transactionItem.code,
          isUseTransactionAllocation: true,
          itemNetAmountWithAllocateDiscountForAllocation: 0,
          itemNetAmountWithAllocateDiscountTotal: 0,
          allocationTransactionList: GetAllocationListWithOutZeroPercent(transactionItem.allocationTransactionList),
          isAcquisitionCost: transactionItem.isAcquisitionCost,
          remainingQuantity: transactionItem.remainingQuantity,
        };

        if (_transactionItem.allocationTransactionList && _transactionItem.allocationTransactionList.length > 0) {
          _transactionItem.isUseTransactionAllocation = GetAllocationTransactionEquals(
            transactionEdit.allocationTransactionList,
            _transactionItem.allocationTransactionList
          );
        }

        const transactionItemForCalculateProductTotalPrice =
          transactionItemHelper.ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);

        const netAmountWithAllocateDiscount = transactionItemHelper.CalculateProductTotalPrice(
          transactionItemForCalculateProductTotalPrice,
          allocateDiscountPercent,
          transaction.transactionCurrency.toCurrencyUid,
          transaction.transactionCurrency.currencyExchangeRates,
          transaction.transactionCurrency.currencyRatio,
          transaction.taxStatus,
          transaction.isCreatedTaxInvoice,
          transaction.transactionType,
          transaction.financeType,
          false
        );

        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountForAllocation = netAmountWithAllocateDiscount.FormatMoney();

        transactionEdit.transactionItemList.push(_transactionItem);
      }
    }

    return transactionEdit;
  },
  IsApprovedInvoice(transactionStatus) {
    return transactionStatus != Enums.QuotationStatus.Draft && transactionStatus != Enums.QuotationStatus.AwaitApproval;
  },
  IsApprovedQuotation(transactionStatus) {
    return transactionStatus != Enums.QuotationStatus.Draft && transactionStatus != Enums.QuotationStatus.AwaitApproval;
  },
  IsApprovedDeposit(transactionStatus) {
    return transactionStatus != Enums.DepositStatus.Draft && transactionStatus != Enums.DepositStatus.AwaitApproval;
  },
  IsApprovedGoodsReceipt(transactionStatus) {
    return (
      transactionStatus != Enums.GoodsReceiptStatus.Draft && transactionStatus != Enums.GoodsReceiptStatus.AwaitApproval
    );
  },
  IsApprovedInvoiceReceipt(transactionStatus) {
    return (
      transactionStatus != Enums.InvoiceReceiptStatus.Draft &&
      transactionStatus != Enums.InvoiceReceiptStatus.AwaitApproval
    );
  },
  IsApprovedReceipt(transactionStatus) {
    return transactionStatus != Enums.ReceiptStatus.Draft && transactionStatus != Enums.ReceiptStatus.AwaitApproval;
  },
  IsApprovedTaxInvoice(transactionStatus) {
    return (
      transactionStatus != Enums.TaxInvoiceStatus.Draft && transactionStatus != Enums.TaxInvoiceStatus.AwaitApproval
    );
  },
  IsApprovedCreditNote(transactionStatus) {
    return (
      transactionStatus != Enums.CreditNoteStatus.Draft && transactionStatus != Enums.CreditNoteStatus.AwaitApproval
    );
  },
  IsApprovedBillingNote(transactionStatus) {
    return (
      transactionStatus != Enums.BillingNoteStatus.Draft && transactionStatus != Enums.BillingNoteStatus.AwaitApproval
    );
  },
  IsApprovedDebitNote(transactionStatus) {
    return transactionStatus != Enums.DebitNoteStatus.Draft && transactionStatus != Enums.DebitNoteStatus.AwaitApproval;
  },
  IsApprovedPurchaseRequisition(transactionStatus) {
    return (
      transactionStatus !== Enums.PurchaseRequisitionStatus.Draft &&
      transactionStatus !== Enums.PurchaseRequisitionStatus.AwaitApproval
    );
  },
  GetExpenseTypeForGetSuggestionTransactionNumber(_transaction) {
    return GetExpenseTypeForGetSuggestionTransactionNumber(_transaction);
  },
  Base64ToBlob(base64, fileType) {
    const binaryString = atob(base64.split(",")[1]);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: fileType });
  },
  GetTransactionViewDetailList(transactionViewDetailRawList) {
    const transactionViewDetailList = [];
    if (transactionViewDetailRawList && transactionViewDetailRawList.length > 0) {
      for (const transactionViewDetailRaw of transactionViewDetailRawList) {
        transactionViewDetailList.push({
          id: transactionViewDetailRaw.id,
          number: transactionViewDetailRaw.number,
          financeType: transactionViewDetailRaw.financeType,
          transactionItemType: transactionViewDetailRaw.transactionItemType,
          contactId: transactionViewDetailRaw.contactId,
          date: transactionViewDetailRaw.date,
        });
      }
    }
    return transactionViewDetailList;
  },
  GetPaymentTransferViewDetailList(paymentTransferViewDetailRawList) {
    const paymentTransferViewDetailList = [];
    if (paymentTransferViewDetailRawList && paymentTransferViewDetailRawList.length > 0) {
      for (const paymentTransferViewDetailRaw of paymentTransferViewDetailRawList) {
        paymentTransferViewDetailList.push({
          paymentGroupId: paymentTransferViewDetailRaw.paymentGroupId,
          journalId: paymentTransferViewDetailRaw.journalId,
          journalNumber: paymentTransferViewDetailRaw.journalNumber,
          contactId: paymentTransferViewDetailRaw.contactId,
        });
      }
    }
    return paymentTransferViewDetailList;
  },
  GetChequeViewDetailList(chequeViewDetailRawList) {
    const chequeViewDetailList = [];
    if (chequeViewDetailRawList && chequeViewDetailRawList.length > 0) {
      for (const chequeViewDetailRaw of chequeViewDetailRawList) {
        chequeViewDetailList.push({
          id: chequeViewDetailRaw.id,
          journalId: chequeViewDetailRaw.journalId,
          journalNumber: chequeViewDetailRaw.journalNumber,
          contactId: chequeViewDetailRaw.contactId,
        });
      }
    }
    return chequeViewDetailList;
  },
  ConvertToImportNumberList(importNumberListRow) {
    const importNumberList = [];
    if (importNumberListRow && importNumberListRow.length > 0) {
      for (const importNumberRaw of importNumberListRow) {
        importNumberList.push({
          id: importNumberRaw.id,
          number: importNumberRaw.number,
        });
      }
    }
    return importNumberList;
  },
  CheckIsLockTransactionCreateStatus(createStatus) {
    return (
      createStatus == Enums.TransactionCreateStatus.OnProcess || createStatus == Enums.TransactionCreateStatus.Error
    );
  },
  IsTransactionHaveDeposit(transactionDetail) {
    return (
      transactionDetail.referenceDepositSummary &&
      (transactionDetail.referenceDepositSummary.fromCurrencyDepositPreVatTotal != 0 ||
        transactionDetail.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal != 0 ||
        transactionDetail.referenceDepositSummary.fromCurrencyDepositZeroVatTotal != 0 ||
        transactionDetail.referenceDepositSummary.fromCurrencyDepositVatTotal != 0 ||
        transactionDetail.referenceDepositSummary.toCurrencyDepositPreVatTotal != 0 ||
        transactionDetail.referenceDepositSummary.toCurrencyDepositVatExemptedTotal != 0 ||
        transactionDetail.referenceDepositSummary.toCurrencyDepositZeroVatTotal != 0 ||
        transactionDetail.referenceDepositSummary.toCurrencyDepositVatTotal != 0)
    );
  },
};
